import mergeToNew from "@insite/client-framework/Common/mergeToNew";
import StyledWrapper, { getStyledWrapper } from "@insite/client-framework/Common/StyledWrapper";
import siteMessage, { siteMessageWithCustomParserOptions } from "@insite/client-framework/SiteMessage";
import ApplicationState from "@insite/client-framework/Store/ApplicationState";
import validatePassword, {
    lowerCasePasswordLengthMessage,
    numberPasswordLengthMessage,
    specialPasswordLengthMessage,
    upperCasePasswordLengthMessage,
} from "@insite/client-framework/Store/CommonHandlers/ValidatePassword";
import { getSettingsCollection } from "@insite/client-framework/Store/Context/ContextSelectors";
import signIn from "@insite/client-framework/Store/Context/Handlers/SignIn";
import { getCreateAccountReturnUrl } from "@insite/client-framework/Store/Pages/CreateAccount/CreateAccountSelectors";
import translate from "@insite/client-framework/Translate";
import { CountryModel, StateModel } from "@insite/client-framework/Types/ApiModels";
import Button, { ButtonPresentationProps } from "@insite/mobius/Button";
import Checkbox from "@insite/mobius/Checkbox";
import CheckboxGroup from "@insite/mobius/CheckboxGroup";
import DatePicker, { DatePickerPresentationProps, DatePickerState } from "@insite/mobius/DatePicker";
import { BaseTheme } from "@insite/mobius/globals/baseTheme";
import GridContainer, { GridContainerProps } from "@insite/mobius/GridContainer";
import GridItem, { GridItemProps } from "@insite/mobius/GridItem";
import Icon, { IconPresentationProps } from "@insite/mobius/Icon";
import AlertTriangle from "@insite/mobius/Icons/AlertTriangle";
import Eye from "@insite/mobius/Icons/Eye";
import EyeOff from "@insite/mobius/Icons/EyeOff";
import Link from "@insite/mobius/Link";
import LoadingOverlay from "@insite/mobius/LoadingOverlay";
import Radio, { RadioComponentProps } from "@insite/mobius/Radio";
import RadioGroup, { RadioGroupComponentProps } from "@insite/mobius/RadioGroup";
import Select, { SelectPresentationProps } from "@insite/mobius/Select";
import TextField, { TextFieldPresentationProps } from "@insite/mobius/TextField";
import Tooltip from "@insite/mobius/Tooltip";
import Typography, { TypographyPresentationProps, TypographyProps } from "@insite/mobius/Typography";
import breakpointMediaQueries from "@insite/mobius/utilities/breakpointMediaQueries";
import FieldSetPresentationProps, { FieldSetGroupPresentationProps } from "@insite/mobius/utilities/fieldSetProps";
import getColor from "@insite/mobius/utilities/getColor";
import InjectableCss from "@insite/mobius/utilities/InjectableCss";
import { DepartmentModel } from "@tCooneyBrothers/ApiModels";
import { formatPhoneNumber } from "@tCooneyBrothers/Common/Utilities/formatPhoneNumber";
import {
    CallbackType,
    ErrorObjectType,
    InputObjectType,
    validate,
    validateConfirmPasswordHandler,
    validatePasswordHandler,
} from "@tCooneyBrothers/Common/Utilities/validate";
import { CreateAccountExistingFormStyles } from "@tCooneyBrothers/Components/CreateAccountExistingForm";
import addAccount from "@tCooneyBrothers/Handlers/AddAccount";
import React, { RefObject } from "react";
import { connect, ResolveThunks } from "react-redux";
import { css } from "styled-components";

import SignInResetPasswordForm from "@insite/content-library/Widgets/SignIn/SignInResetPasswordForm";
import {
    FormErrorsStateType,
    intialErrorFormState,
    intialErrorFormStateForCreditApp,
    newCustomerCreditValidatorConfig,
    newCustomerValidatorConfig,
    ValidatorConfigType,
} from "@tCooneyBrothers/Components/CreateAccountNewFormValidatorConfig";

import { parserOptions } from "@insite/client-framework/Common/BasicSelectors";
import LoadingSpinner from "@insite/mobius/LoadingSpinner";
import Modal, { ModalPresentationProps } from "@insite/mobius/Modal";
import ToasterContext from "@insite/mobius/Toast/ToasterContext";
import { HasHistory, withHistory } from "@insite/mobius/utilities/HistoryContext";
import ReCaptcha from "@tCooneyBrothers/Components/ReCaptcha";
import ReCAPTCHA from "react-google-recaptcha";

export interface CreateAccountNewFormStyles {
    wrapper?: InjectableCss;
    addressText?: TypographyProps;
    cityStatePostalCodeText?: TypographyProps;
    countryText?: TypographyProps;
    mainGridContainer?: GridContainerProps;
    mainContainer?: InjectableCss;
    userGridItem?: GridItemProps;
    userGridContainer?: GridContainerProps;
    emailGridItem?: GridItemProps;
    emailTextField?: TextFieldPresentationProps;
    userNameGridItem?: GridItemProps;
    userNameTextField?: TextFieldPresentationProps;
    passwordGridItem?: GridItemProps;
    passwordTextField?: TextFieldPresentationProps;
    confirmPasswordTextField?: TextFieldPresentationProps;
    confirmPasswordGridItem?: GridItemProps;
    confirmPasswordIcon?: IconPresentationProps;
    subscriptionGridItem?: GridItemProps;
    submitErrorGridItem?: GridItemProps;
    submitErrorTitle?: TypographyProps;
    submitGridItem?: GridItemProps;
    submitButton?: ButtonPresentationProps;
    centeringWrapper?: InjectableCss;
    requirementsGridItem?: GridItemProps;
    passwordRequirementsGridContainer?: GridContainerProps;
    passwordRequirementsGridItem?: GridItemProps;
    requirementsTitle?: TypographyProps;
    formsTopNav?: InjectableCss;
    passwordIcon?: IconPresentationProps;
    messageFilterGridItem?: GridItemProps;
    messageFilter?: MessageFilterStyles;
    fromDate?: DatePickerPresentationProps;
    attributeTypeText?: TypographyPresentationProps;
    select?: SelectPresentationProps;
    CreateAccountExistingFormStyles?: CreateAccountExistingFormStyles;
    subHeading?: InjectableCss;
    refCustomInputCss?: InjectableCss;
    sectionLabel?: InjectableCss;
    sectionDivider?: InjectableCss;
    halfWidthCustomInputCss?: InjectableCss;
    borderTop?: InjectableCss;
    borderBottom?: InjectableCss;
    radioWithFlex?: InjectableCss;
    departmentSelect: SelectPresentationProps;
    formStepsNumber?: InjectableCss;
    formStepsHeading?: InjectableCss;
    centerAlignFlexbox?: InjectableCss;
    underline?: InjectableCss;
    errorMessageStyle?: InjectableCss;
    startDateGridItem?: GridItemProps;
    startDatePicker?: DatePickerPresentationProps;
    halfWidthDatePickerCss?: InjectableCss;
    shipToBillToCheck?: InjectableCss;
    creditApplicationLastDiv?: InjectableCss;
    checkboxAlignment?: InjectableCss;
    marginBottom?: InjectableCss;
    oneFourthGridItem?: GridItemProps;
    thirdFourthGridItem?: GridItemProps;
    inputWithLenthyLabelCss?: InjectableCss;
    fullWidthInput?: InjectableCss;
    fullWidth?: InjectableCss;
    columnLayout?: InjectableCss;
    gridOffsetMargin?: GridContainerProps;
    resetPasswordModal?: ModalPresentationProps;
    errorMsgWrap?: InjectableCss;
    salesTaxExemptMsg?: InjectableCss;
}

interface MessageFilterStyles {
    radioGroup?: FieldSetGroupPresentationProps<RadioGroupComponentProps>;
    radioButton?: FieldSetPresentationProps<RadioComponentProps>;
}

export const CreateAccountNewFormStyles: CreateAccountNewFormStyles = {
    mainContainer: {
        css: css`
            > [class^="GridWrapper"] {
                padding-left: 0 !important;
                > [class^="GridOffset"] {
                    width: 100% !important;
                    margin: 0 !important;
                }
            }
        `,
    },
    wrapper: {
        css: css`
            font-style: normal;
            [class^="GridOffset"] {
                width: 100%;
            }
            [class^="CheckboxGroupStyle"] {
                margin-top: 0 !important;
            }
            [class^="RadioGroupStyle"] {
                legend {
                    margin: 0;
                }
            }
            .fullWidthForMobileDevices {
                > div {
                    ${({ theme }: { theme: BaseTheme }) =>
                        breakpointMediaQueries(
                            theme,
                            [
                                null,
                                null,
                                css`
                                    width: 100% !important;
                                `,
                            ],
                            "max",
                        )}
                }
            }
        `,
    },
    addressText: { as: "p" },
    cityStatePostalCodeText: { as: "p" },
    countryText: { as: "p" },
    centeringWrapper: {
        css: css`
            display: flex;
            height: 300px;
            justify-content: center;
            align-items: center;
        `,
    },
    userGridItem: {
        width: [12, 12, 6, 6, 6],
        css: css`
            flex-direction: column;
            ${({ theme }: { theme: BaseTheme }) =>
                breakpointMediaQueries(
                    theme,
                    [
                        null,
                        null,
                        css`
        padding - left: 100 px;
        `,
                    ],
                    "min",
                )}
        `,
    },
    userGridContainer: {
        css: css`
            ${({ theme }: { theme: BaseTheme }) =>
                breakpointMediaQueries(
                    theme,
                    [
                        null,
                        null,
                        css`
        max - width: 300 px;
        `,
                    ],
                    "min",
                )}
        `,
    },
    resetPasswordModal: {
        sizeVariant: "small",
    },
    emailGridItem: {
        width: 12,
    },
    userNameGridItem: {
        width: 12,
    },
    passwordGridItem: {
        width: 12,
    },
    confirmPasswordGridItem: {
        width: 12,
    },
    subscriptionGridItem: {
        width: 12,
    },
    submitErrorGridItem: {
        width: 12,
    },
    submitErrorTitle: {
        color: "danger",
    },
    submitGridItem: {
        width: 12,
        css: css`
            justify-content: flex-end;
        `,
    },
    requirementsGridItem: {
        width: [12, 12, 6, 6, 6],
        css: css`
            flex-direction: column;
            ${({ theme }: { theme: BaseTheme }) =>
                breakpointMediaQueries(
                    theme,
                    [
                        null,
                        null,
                        css`
        padding - left: 50 px;
        `,
                    ],
                    "min",
                )}/* stylelint-disable-line declaration-block-single-line-max-declarations */
        `,
    },
    passwordRequirementsGridContainer: {
        gap: 5,
    },
    passwordRequirementsGridItem: {
        width: 12,
    },
    requirementsTitle: {
        variant: "h4",
        as: "h2",
    },
    formsTopNav: {
        css: css`
            display: flex;
        `,
    },
    messageFilterGridItem: { width: 12 },
    messageFilter: {
        radioGroup: {
            css: css`
                display: flex;
                flex-direction: row;
                justify-content: center;
                align-items: center;
            `,
        },
    },
    fromDate: {
        cssOverrides: {
            inputSelect: css`
                width: 100%;
            `,
            formField: css`
                padding-right: 10px;
            `,
        },
    },
    subHeading: {
        css: css`
            background-color: #ef3742;
            color: #fff;
            text-transform: uppercase;
            width: 100%;
            padding: 8px 15px;
            margin-bottom: 30px;
            font-weight: bold;
        `,
    },
    refCustomInputCss: {
        css: css`
            max-width: 100%;
            width: 100%;
            display: inline-block;
            vertical-align: top;
            margin-bottom: 10px;
            margin-top: 10px;
            ${({ theme }: { theme: BaseTheme }) =>
                breakpointMediaQueries(
                    theme,
                    [
                        null,
                        null,
                        css`
                            max-width: 100%;
                        `,
                    ],
                    "max",
                )}
            > div[class^="FormFieldStyle"] {
                position: relative;
                > label {
                    font-size: 13px;
                    position: absolute;
                    z-index: 1;
                    padding-left: 5px;
                    background-color: #fff;
                    display: inline-block;
                    width: auto;
                    left: 20px;
                    ${({ theme }: { theme: BaseTheme }) =>
                        breakpointMediaQueries(
                            theme,
                            [
                                css`
                                    font-size: 12px;
                                    left: 14px;
                                    padding-left: 3px;
                                `,
                                null,
                                null,
                            ],
                            "max",
                        )}
                }
            }
        `,
    },
    sectionLabel: {
        css: css`
            color: #0f0f0f;
            font-weight: 600;
        `,
    },
    sectionDivider: {
        css: css`
            border-bottom: 1px solid #efefef;
            margin-top: 10px;
            padding-bottom: 20px;
            margin-bottom: 20px;
            padding-left: 0;
            padding-right: 0;
            ${({ theme }: { theme: BaseTheme }) =>
                breakpointMediaQueries(
                    theme,
                    [
                        null,
                        null,
                        css`
                            flex-direction: column;
                        `,
                    ],
                    "max",
                )}
        `,
    },
    departmentSelect: {
        labelProps: {
            css: css`
                width: 100%;
            `,
        },
        cssOverrides: {
            formField: css`
                width: 100%;
            `,
        },
    },
    halfWidthCustomInputCss: {
        css: css`
            width: 50%;
            display: inline-block;
            vertical-align: top;
            margin-bottom: 10px;
            margin-top: 10px;
            padding-right: 20px;
            ${({ theme }: { theme: BaseTheme }) =>
                breakpointMediaQueries(
                    theme,
                    [
                        null,
                        null,
                        css`
                            width: 100%;
                            padding-right: 0;
                        `,
                    ],
                    "max",
                )}
            > div[class^="FormFieldStyle"] {
                position: relative;
                > label {
                    font-size: 13px;
                    position: absolute;
                    z-index: 1;
                    padding-left: 5px;
                    background-color: #fff;
                    display: inline-block;
                    width: auto;
                    left: 20px;
                    ${({ theme }: { theme: BaseTheme }) =>
                        breakpointMediaQueries(
                            theme,
                            [
                                css`
                                    font-size: 12px;
                                    left: 14px;
                                    padding-left: 3px;
                                `,
                                null,
                                null,
                            ],
                            "max",
                        )}
                }
            }
        `,
    },
    inputWithLenthyLabelCss: {
        css: css`
            width: 100%;
            display: inline-block;
            vertical-align: top;
            margin-bottom: 10px;
            margin-top: 10px;
            padding-right: 20px;
            ${({ theme }: { theme: BaseTheme }) =>
                breakpointMediaQueries(
                    theme,
                    [
                        null,
                        null,
                        css`
                            width: 100%;
                            padding-right: 0;
                        `,
                    ],
                    "max",
                )}
            > div[class^="FormFieldStyle"] {
                position: relative;
                > label {
                    font-size: 13px;
                    position: absolute;
                    z-index: 1;
                    padding-left: 5px;
                    background-color: #fff;
                    display: inline-block;
                    width: auto;
                    left: 20px;
                    // text-transform: capitalize;
                    ${({ theme }: { theme: BaseTheme }) =>
                        breakpointMediaQueries(
                            theme,
                            [
                                css`
                                    font-size: 12px;
                                    left: 14px;
                                    padding-left: 3px;
                                `,
                                null,
                                null,
                            ],
                            "max",
                        )}
                }
                /* > div[class^="FormInputWrapper"] input {
                    ${({ theme }: { theme: BaseTheme }) =>
                    breakpointMediaQueries(
                        theme,
                        [
                            css`
                                height: 60px;
                            `,
                            null,
                            null,
                        ],
                        "max",
                    )}
                } */
            }
        `,
    },
    borderTop: {
        css: css`
            border-top: 1px solid #efefef;
        `,
    },
    borderBottom: {
        css: css`
            border-bottom: 1px solid #efefef;
        `,
    },
    radioWithFlex: {
        css: css`
            display: flex;
            justify-content: flex-start;
            flex-direction: row;
            > div[class^="RadioStyle"] {
                margin-right: 20px;
                margin-top: 0 !important;
                > label[class^="TypographyStyle"] {
                    font-size: 13px;
                }
            }
        `,
    },
    formStepsNumber: {
        css: css`
            font-size: 100px;
            font-weight: bold;
            padding-right: 5px;
            color: #e9e9e9;
        `,
    },
    formStepsHeading: {
        css: css`
            text-transform: capitalize;
            font-weight: bold;
        `,
    },
    centerAlignFlexbox: {
        css: css`
            display: flex;
            justify-content: space-between;
            align-items: center;
            ${({ theme }: { theme: BaseTheme }) =>
                breakpointMediaQueries(
                    theme,
                    [
                        null,
                        null,
                        css`
                            margin-bottom: 10px;
                        `,
                    ],
                    "max",
                )}
        `,
    },
    underline: {
        css: css`
            text-decoration: underline;
            // text-transform: uppercase;
            color: ${getColor("primary")};
            span {
                color: ${getColor("primary")} !important;
                font-size: 14px;
                font-weight: 600;
            }
        `,
    },
    errorMessageStyle: {
        css: css`
            //color: ${getColor("danger")};
            color: #1a3065;
            font-weight: 600;
            padding: 10px;
            width: 100%;
            background-color: #ff9832;
        `,
    },
    startDateGridItem: {
        width: [12, 6, 6, 6, 6],
        css: css`
            flex-direction: column;
            align-items: initial;
        `,
    },
    halfWidthDatePickerCss: {
        css: css`
            width: 50%;
            display: inline-block;
            vertical-align: top;
            margin-bottom: 10px;
            margin-top: 10px;
            padding-right: 20px;
            ${({ theme }: { theme: BaseTheme }) =>
                breakpointMediaQueries(
                    theme,
                    [
                        null,
                        null,
                        css`
                            width: 100%;
                            padding-right: 0;
                        `,
                    ],
                    "max",
                )}
            > div[class^="FormFieldStyle"] {
                position: relative;
                width: 100%;
                > label {
                    font-size: 13px;
                    position: absolute;
                    z-index: 1;
                    padding-left: 5px;
                    background-color: #fff;
                    display: inline-block;
                    width: auto;
                    left: 20px;
                    text-transform: capitalize;
                    ${({ theme }: { theme: BaseTheme }) =>
                        breakpointMediaQueries(
                            theme,
                            [
                                css`
                                    font-size: 12px;
                                    left: 14px;
                                    padding-left: 3px;
                                `,
                                null,
                                null,
                            ],
                            "max",
                        )}
                }
                > div[class^="FormInputWrapper"] > div > div[class^="react-datetime-picker"] {
                    font-size: 13px;
                }
            }
        `,
    },
    shipToBillToCheck: {
        css: css`
            width: 100%;
        `,
    },
    marginBottom: {
        css: css`
            margin-bottom: 30px;
        `,
    },
    creditApplicationLastDiv: {
        css: css`
            padding: 15px 0 !important;
            margin-bottom: 15px;
            ${({ theme }: { theme: BaseTheme }) =>
                breakpointMediaQueries(
                    theme,
                    [
                        null,
                        null,
                        css`
                            flex-direction: column;
                            display: block;
                        `,
                    ],
                    "max",
                )}
        `,
    },
    oneFourthGridItem: {
        width: [12, 12, 12, 4, 4],
        css: css`
            padding: 0;
            padding-left: 0;
            ${({ theme }: { theme: BaseTheme }) =>
                breakpointMediaQueries(
                    theme,
                    [
                        null,
                        null,
                        css`
                            display: block;
                            padding: 0 0 15px;
                        `,
                    ],
                    "max",
                )}
        `,
    },

    thirdFourthGridItem: {
        width: [12, 12, 12, 5, 5],
        css: css`
            flex-direction: column;
            padding: 0 15px;
            ${({ theme }: { theme: BaseTheme }) =>
                breakpointMediaQueries(
                    theme,
                    [
                        null,
                        null,
                        css`
                            display: block;
                            padding: 0;
                        `,
                    ],
                    "max",
                )}
        `,
    },
    columnLayout: {
        css: css`
            display: flex;
            flex-direction: column;
        `,
    },
    fullWidthInput: {
        css: css`
            width: 100%;
            margin-top: 15px;
        `,
    },
    fullWidth: {
        css: css`
            width: 100%;
        `,
    },
    gridOffsetMargin: {
        css: css`
            [class^="GridOffset"] {
                margin: 0;
                width: 100%;
            }
        `,
    },
    checkboxAlignment: {
        css: css`
            margin-top: 20px;
            > div[class^="CheckboxStyle"] {
                > label {
                    font-size: 13px;
                }
            }
        `,
    },
    errorMsgWrap: {
        css: css`
            width: 100%;
            display: block;
        `,
    },
    salesTaxExemptMsg: {
        css: css`
            margin-bottom: 14px;
        `,
    },
    submitButton: {
        css: css`
            &.buttonTransition {
                background: linear-gradient(to left, #ea636b 50%, #ef3742 50%);
                background-size: 200% 100%;
                background-position: left bottom;
                animation: gradient-animation 9s ease-in-out infinite;
                @keyframes gradient-animation {
                    0% {
                        background-position: right bottom;
                    }
                    100% {
                        background-position: left top;
                    }
                }
            }
        `,
    },
};

const mapDispatchToProps = {
    addAccount,
    signIn,
    validatePassword,
};

interface OwnProps {
    extendedStyles?: CreateAccountNewFormStyles;
    retrunUrl?: any;
    departments?: DepartmentModel[];
    countries?: CountryModel[];
    validateReCaptcha?: any;
    isCreateNewCustomerPage?: boolean;
    homePageUrl?: string;
}

const mapStateToProps = (state: ApplicationState) => ({
    accountSettings: getSettingsCollection(state).accountSettings,
    returnUrl: getCreateAccountReturnUrl(state),
});

type Props = OwnProps & ReturnType<typeof mapStateToProps> & ResolveThunks<typeof mapDispatchToProps> & HasHistory;

const emailRegexp = new RegExp("\\w+([-+.']\\w+)*@\\w+([-.]\\w+)*\\.\\w+([-.]\\w+)*");

const CreateAccountNewForm: React.FunctionComponent<Props> = function Address(props: Props) {
    const selCountry = props!.countries!.find(option => option.name === "United States");
    const depWithOther = props?.departments && props?.departments.filter(a => a.description === "Other");
    const depWithoutOther = props?.departments && props?.departments.filter(a => a.description !== "Other");
    const department = depWithoutOther && depWithOther && depWithoutOther.push(depWithOther[0]);
    const [depState, setDepState] = React.useState(depWithoutOther && depWithoutOther[0]);
    const isCreateNewCustomerPage = !!props.isCreateNewCustomerPage;

    const [country, setCountry] = React.useState<CountryModel | undefined>(selCountry);
    const defaultCountry = country || selCountry;
    const [defaultStates, setDefaultStates] = React.useState<StateModel[]>([]);
    const [billToState, setBillToState] = React.useState<StateModel | undefined>(
        selCountry && selCountry.states ? selCountry.states[0] : undefined,
    );

    const [shipToCountry, setShipToCountry] = React.useState<CountryModel | undefined>(selCountry);
    const defaultShipToCountry = shipToCountry || selCountry;

    if (!defaultShipToCountry?.states) {
        return null;
    }
    const statesStartWithP =
        defaultShipToCountry?.states &&
        defaultShipToCountry?.states.filter(val => {
            return val.name.startsWith("P");
        });
    const rearrangedDataP = [statesStartWithP[1], statesStartWithP[2], statesStartWithP[0]];
    const statesEndWithO =
        defaultShipToCountry?.states &&
        defaultShipToCountry?.states.findIndex(val => {
            return val.name.startsWith("P");
        });
    const splitStateStillO = defaultShipToCountry?.states?.slice(0, statesEndWithO);
    const splitStateAfterP = defaultShipToCountry?.states?.slice(
        statesEndWithO + statesStartWithP.length,
        defaultShipToCountry?.states.length,
    );
    const rearrangedStates = [...splitStateStillO, ...rearrangedDataP, ...splitStateAfterP];
    const [defaultShipToStates, setDefaultShipToStates] = React.useState<StateModel[]>([]);
    const [shipToState, setShipToState] = React.useState<StateModel | undefined>(
        selCountry && selCountry.states ? selCountry.states[0] : undefined,
    );

    const firstNameErrorMsg = siteMessage("createAccountInfo_FirstNameRequired");
    const lastNameErrorMsg = siteMessage("createAccountInfo_LastNameRequired");
    const emailRequiredFieldMessage = siteMessage("createAccountInfo_Email_Required");
    const emailFieldMessage = siteMessage("CreateNewAccountInfo_EmailAddress_ValidEmail");
    const phoneErrorMsg = siteMessage("createAccountInfo_PhoneNoRequired");
    const shipToPhoneErrorMsg = siteMessage("createAccountInfo_ShipToPhoneNoRequired");
    const validPhoneMsg = siteMessage("createAccountInfo_PhoneNoValidation");
    const shipToValidPhoneMsg = siteMessage("createAccountInfo_ShipToPhoneNoValidation");
    const passwordErrorMsg = siteMessage("createAccountInfo_PasswordRequired");
    const confirmPasswordErrorMsg = siteMessage("createAccountInfo_PasswordConfirmationRequired");
    const address1ErrorMsg = siteMessage("createAccountInfo_Address1Required");
    const shipToAddress1ErrorMsg = siteMessage("createAccountInfo_ShipToAddress1Required");
    const cityErrorMsg = siteMessage("createAccountInfo_CityRequired");
    const shipToCityErrorMsg = siteMessage("createAccountInfo_ShipToCityRequired");
    const shipToCityValidErrorMsg = siteMessage("createAccountInfo_ShipToCityValid"); // Please verify that only the city is filled in.
    const postalCodeErrorMsg = siteMessage("createAccountInfo_PostalcodeRequired");
    const shippingPostalCodeErrorMsg = siteMessage("createAccountInfo_ShippingPostalcodeRequired");
    const companyNameErrorMsg = siteMessage("createAccountInfo_CompanyNameRequired");

    const [returnUrl, setReturnUrl] = React.useState(props.returnUrl);
    const [styles] = React.useState(() => mergeToNew(CreateAccountNewFormStyles, props.extendedStyles));
    const [email, setEmail] = React.useState("");
    const [userName, setUserName] = React.useState(email);
    const [password, setPassword] = React.useState(isCreateNewCustomerPage ? "Smtp.net4@india" : "");
    const [confirmPassword, setConfirmPassword] = React.useState(isCreateNewCustomerPage ? "Smtp.net4@india" : "");
    const [isSubmitted, setIsSubmitted] = React.useState(false);
    const [submitClicked, setSubmitClicked] = React.useState(false);
    const [showPassword, setShowPassword] = React.useState(false);
    const [confirmPasswordErrorMessage, setConfirmPasswordErrorMessage] = React.useState<React.ReactNode>("");
    const [showConfirmPassword, setShowConfirmPassword] = React.useState(false);
    const [passwordErrorMessage, setPasswordErrorMessage] = React.useState<React.ReactNode>("");
    // const [isSubscribed, setIsSubscribed] = React.useState(true);
    const [errorMessage, setErrorMessage] = React.useState("");
    const toasterContext = React.useContext(ToasterContext);
    const [firstName, setFirstName] = React.useState("");
    const [firstNameError, setFirstNameError] = React.useState(firstNameErrorMsg);
    const [lastName, setLastName] = React.useState("");
    const [lastNameError, setLastNameError] = React.useState(lastNameErrorMsg);
    const [emailError, setEmailError] = React.useState(emailRequiredFieldMessage);
    const [phone, setPhone] = React.useState("");
    const [phoneError, setPhoneError] = React.useState(phoneErrorMsg);
    const [shipToPhoneError, setShipToPhoneError] = React.useState(shipToPhoneErrorMsg);
    const [customerNumberProvided, setCustomerNumberProvided] = React.useState(false);
    const [companyName, setCompanyName] = React.useState("");
    const [companyError, setCompanyError] = React.useState(companyNameErrorMsg);
    const [IsShipToSameAsBilling, setIsShipToSameAsBillTo] = React.useState(true);
    const [address1, setCustomerAddress1] = React.useState("");
    const [address1Error, setCustomerAddress1Error] = React.useState(address1ErrorMsg);
    const [shipToAddress1Error, setShipToCustomerAddress1Error] = React.useState(shipToAddress1ErrorMsg);
    const [address2, setCustomerAddress2] = React.useState("");
    const [postalCode, setPostalCode] = React.useState("");
    const [postalCodeError, setPostalCodeError] = React.useState(postalCodeErrorMsg);
    const [shippingPostalCodeError, setShippingPostaCodeError] = React.useState(shippingPostalCodeErrorMsg);
    const [city, setCity] = React.useState("");
    const [cityError, setCityError] = React.useState(cityErrorMsg);
    const [shiToCityError, setshiToCityError] = React.useState(shipToCityErrorMsg);
    const [address1ShipTo, setShipToAddress1] = React.useState("");
    const [address2ShipTo, setShipToAddress2] = React.useState("");
    const [cityShipTo, setShipToCity] = React.useState("");
    const [zipShipTo, setShipToPostalCode] = React.useState("");
    const [phoneShipTo, setShipToPhone] = React.useState("");
    const [companyNameShipTo, setShipToCompanyName] = React.useState("");
    const [IsCreditAccount, setIsCreditAccount] = React.useState(false);
    const [IsCreditAccountErrorMsg, setIsCreditAccountErrorMsg] = React.useState(false);
    const [organizationStructure, setOrganizationStructure] = React.useState("");
    const [stateDateIncorporated, setStateDateIncorporated] = React.useState("");
    const [companyOperationalTime, setCompanyOperationalTime] = React.useState("");
    const [principalActivity, setPrincipalActivity] = React.useState("");
    const [IsCompanyNameChanged, setIsCompanyNameChanged] = React.useState("No");
    const [formerName, setFormerName] = React.useState("");
    const [IsPastBought, setIsPastBought] = React.useState("No");
    const [pastBuyerName, setPastBuyerName] = React.useState("");
    const [creditLimit, setCreditLimit] = React.useState("");
    const [IsSalesTaxExempt, setIsSalesTaxExempt] = React.useState("No");
    const [apContact, setApContact] = React.useState("");
    const [apContactEmail, setApContactEmail] = React.useState("");
    const [invUSPostalMail, setUSPostalMail] = React.useState("");
    const [invFlag, setInvFlag] = React.useState("");
    const [bankName, setBrcFirstname] = React.useState("");
    const [bankAccount, setBrcAccount] = React.useState("");
    const [bankAddress, setBrcAddress] = React.useState("");
    const [bankPhone, setBrcPhoneNumber] = React.useState("");
    const [bankFax, setBrcFax] = React.useState("");
    const [businessRefCompName1, setBusinessRefCompName1] = React.useState("");
    const [businessRefName1, setBusinessRefName1] = React.useState("");
    const [businessRefTitle1, setBusinessRefTitle1] = React.useState("");
    const [businessRefAddress1, setBusinessRefAddress1] = React.useState("");
    const [businessRefPhone1, setBusinessRefPhone1] = React.useState("");
    const [businessRefFax1, setBusinessRefFax1] = React.useState("");
    const [businessRefCompName2, setBusinessRefCompName2] = React.useState("");
    const [businessRefName2, setBusinessRefName2] = React.useState("");
    const [businessRefTitle2, setBusinessRefTitle2] = React.useState("");
    const [businessRefAddress2, setBusinessRefAddress2] = React.useState("");
    const [businessRefPhone2, setBusinessRefPhone2] = React.useState("");
    const [businessRefFax2, setBusinessRefFax2] = React.useState("");
    const [IsBankrupt, setIsBankrupt] = React.useState("No");
    const [IsSuitFiled, setIsSuitFiled] = React.useState("No");
    const [IsUpsAccount, setIsUpsAccount] = React.useState("");
    const [upsAccount, setUpsAccount] = React.useState("");
    const [receivingHours, setReceivingHours] = React.useState("");
    const [IsTerms, setIsTerms] = React.useState("");
    const [InvoicesBeSent, setInvoicesBeSent] = React.useState("e-mail");
    const [invEmailText, setInvEmail] = React.useState("");
    const [invFaxNumberText, setInvFaxNumber] = React.useState("");
    const [suitFiledText, setSuitFiledText] = React.useState("");
    const [IsBankruptText, setIsBankruptText] = React.useState("");
    const [formErrors, setFormErrors] = React.useState<FormErrorsStateType>(intialErrorFormState);
    const [formErrorsForCredit, setFormErrorsForCredit] = React.useState<FormErrorsStateType>(
        intialErrorFormStateForCreditApp,
    );
    const [isButtonDisabled, setIsButtonDisabled] = React.useState(true);
    const [isCreditFormButtonDisabled, setIsCreditFormButtonDisabled] = React.useState(true);
    const [businessStartDate, setBusinessStartDate] = React.useState("");
    const StyledSpan = getStyledWrapper("span");
    const [showExistEmail, setshowExistEmail] = React.useState(false);
    const [isResetPasswordModalOpen, setIsResetPasswordModalOpen] = React.useState(false);
    const [showLoadingState, setLoadingState] = React.useState(false);
    const [buttonTransition, setButtonTransition] = React.useState(false);

    const { validateReCaptcha } = props;
    const recaptchaRef: RefObject<ReCAPTCHA | null> = React.createRef();

    const validateEmail = (email: string) => {
        const errorMessage = !email ? emailRequiredFieldMessage : emailRegexp.test(email) ? "" : emailFieldMessage;
        setEmailError(errorMessage);
        return !errorMessage;
    };

    const validateConfirmPassword = (newPassword: string, newConfirmPassword: string) => {
        const errorMessage =
            newPassword !== newConfirmPassword
                ? siteMessage("CreateNewAccountInfo_PasswordCombination_DoesNotMatch")
                : "";
        setConfirmPasswordErrorMessage(errorMessage);
        return !errorMessage;
    };

    const validateSubmitDisabled = (errorsState: FormErrorsStateType) => {
        return Object.keys(errorsState).length !== 0;
    };

    React.useEffect(() => {
        setIsCreditFormButtonDisabled(validateSubmitDisabled(formErrorsForCredit));
    }, [formErrorsForCredit]);

    React.useEffect(() => {
        const selectStateEl: HTMLSelectElement | null = document.querySelector('[name="selectState"]');
        if (selectStateEl) {
            validateHandler(selectStateEl);
        }
    }, [country]);

    React.useEffect(() => {
        const selectStateEl: HTMLSelectElement | null = document.querySelector('[name="SelectShipToState"]');
        if (selectStateEl) {
            validateHandler(selectStateEl);
        }
    }, [shipToCountry]);

    React.useEffect(() => {
        const cloneFormErrors = { ...formErrors };
        for (const [key, value] of Object.entries(cloneFormErrors)) {
            const element: HTMLSelectElement | HTMLInputElement | null = document.querySelector(`[name="${key}"]`);
            if (element && element.value) {
                delete cloneFormErrors[key as keyof FormErrorsStateType];
                setFormErrors(removeKey(cloneFormErrors, key));
            }
        }
        setShippingAddressSameAsBillingAddressOnLoad(true);
    }, []);

    const onResetPasswordClose = () => {
        setIsResetPasswordModalOpen(false);
    };

    const validateHandler = (input: HTMLInputElement | HTMLSelectElement, customValidation?: CallbackType): void => {
        const inputObject: InputObjectType = {
            name: input.name,
            value: input.value,
        };
        const validatorConfig = newCustomerValidatorConfig[input.name as keyof ValidatorConfigType];
        const selectedCountry = input.name === "SelectShipToState" ? shipToCountry : country;
        const isStateOptional =
            (input.name === "selectState" || input.name === "SelectShipToState") &&
            selectedCountry?.abbreviation !== "US" &&
            selectedCountry?.abbreviation !== "CA";
        const validationConfig = isStateOptional ? { ...validatorConfig, required: false } : validatorConfig;
        const isValidate: ErrorObjectType | undefined = validate(inputObject, validationConfig, customValidation);

        if (isValidate === undefined) {
            delete formErrors[input.name as keyof FormErrorsStateType];
            setFormErrors(removeKey(formErrors, input.name));
        } else {
            setFormErrors(prevState => {
                return {
                    ...prevState,
                    [input.name]: isValidate ? isValidate.errorMsg : isValidate,
                };
            });
        }
        if (!validationConfig.required && input.value === "") {
            delete formErrors[input.name as keyof FormErrorsStateType];
            setFormErrors(formErrors);
        }
        if (!IsCreditAccount) {
            setIsButtonDisabled(validateSubmitDisabled(formErrors));
        }
    };

    const removeKey = (formErrorObject: FormErrorsStateType, deleteKey: string) => {
        return Object.assign(
            {},
            ...Object.entries(formErrorObject)
                .filter(([k]) => k !== deleteKey)
                .map(([k, v]) => ({ [k]: v })),
        );
    };

    const validateHandlerForCredit = (
        input: HTMLInputElement | HTMLSelectElement,
        customValidation?: CallbackType,
    ): void => {
        const inputObject: InputObjectType = {
            name: input.name,
            value: input.value,
        };
        if (invFlag === "Email" || invFlag === "Fax") {
            formErrorsForCredit.invEmailText = "";
            formErrorsForCredit.invFaxText = "";
            setFormErrorsForCredit(formErrorsForCredit);
            if (InvoicesBeSent === "e-mail") {
                delete formErrorsForCredit["invFaxText" as keyof FormErrorsStateType];
                setFormErrorsForCredit(formErrorsForCredit);
            }
            if (InvoicesBeSent === "fax number") {
                delete formErrorsForCredit["invEmailText" as keyof FormErrorsStateType];
                setFormErrorsForCredit(formErrorsForCredit);
            }
            setInvFlag("");
        }
        const validatorConfig = newCustomerCreditValidatorConfig[input.name as keyof ValidatorConfigType];
        const isValidate: ErrorObjectType | undefined = validate(inputObject, validatorConfig, customValidation);
        if (isValidate === undefined) {
            delete formErrorsForCredit[input.name as keyof FormErrorsStateType];
            setFormErrorsForCredit(formErrorsForCredit);
        } else {
            setFormErrorsForCredit({
                ...formErrorsForCredit,
                [input.name]: isValidate ? isValidate.errorMsg : isValidate,
            });
        }

        if (!validatorConfig.required && input.value === "") {
            delete formErrorsForCredit[input.name as keyof FormErrorsStateType];
            setFormErrorsForCredit(formErrorsForCredit);
        }
        setIsButtonDisabled(validateSubmitDisabled(formErrors));
        setIsCreditFormButtonDisabled(validateSubmitDisabled(formErrorsForCredit));
    };

    const validationRemoveHandler = (inputName: string): void => {
        delete formErrorsForCredit[inputName as keyof FormErrorsStateType];
        setFormErrorsForCredit(formErrorsForCredit);
        setIsButtonDisabled(validateSubmitDisabled(formErrors));
        setIsCreditFormButtonDisabled(validateSubmitDisabled(formErrorsForCredit));
    };
    const emailChangeHandler = (input: HTMLInputElement) => {
        validateEmail(input.value);
        setEmail(input.value);
        setUserName(input.value);
    };
    const passwordChangeHandler = (input: HTMLInputElement) => {
        validateConfirmPassword(input.value, confirmPassword);
        validatePassword({
            password: input.value,
            onComplete: errorMessage => {
                setPasswordErrorMessage(errorMessage);
            },
        });
        setPassword(input.value);
        pwdHandler(input);
    };

    const confirmPasswordChangeHandler = (input: HTMLInputElement) => {
        setConfirmPassword(input.value);
        validateConfirmPassword(password, input.value);
        pwdHandler(input);
    };

    const pwdHandler = (input: HTMLInputElement) => {
        const pwd = input.name === "password" ? input.value : password;
        const confirmPwd = input.name === "confirmPassword" ? input.value : confirmPassword;

        const isValidate: ErrorObjectType | undefined =
            input.name === "password"
                ? validatePasswordHandler(pwd, confirmPwd, props.accountSettings)
                : validateConfirmPasswordHandler(pwd, confirmPwd);
        if (isValidate === undefined) {
            delete formErrors[input.name as keyof FormErrorsStateType];
            setFormErrors(removeKey(formErrors, input.name));
        } else {
            setFormErrors({
                ...formErrors,
                [input.name]: isValidate ? isValidate.errorMsg : isValidate,
            });
        }
    };
    const onBlurValidationHandler = (input: HTMLInputElement | HTMLSelectElement) => {
        validateHandler(input);
    };

    const onBlurCreditFormValidationHandler = (input: HTMLInputElement | HTMLSelectElement) => {
        validateHandlerForCredit(input);
    };

    const validateSubmitEnabled = () => {
        let submitEnable = true;
        if (
            emailError ||
            firstNameError ||
            lastNameError ||
            phoneError ||
            address1Error ||
            companyError ||
            passwordErrorMessage ||
            confirmPasswordErrorMessage ||
            cityError ||
            postalCodeError
        ) {
            submitEnable = false;
        }
        if (!IsShipToSameAsBilling) {
            if (shiToCityError || shipToPhoneError || shipToAddress1Error || shippingPostalCodeError) {
                submitEnable = false;
            }
        }
        return submitEnable;
    };

    const scrollToFirstFormError = () => {
        const firstErrorElement = document.querySelector("[aria-invalid='true']");
        if (firstErrorElement) {
            const formFieldParent = firstErrorElement.closest("[class*='FormFieldStyle']");
            if (!formFieldParent) {
                return;
            }
            const { top } = formFieldParent.getBoundingClientRect();
            formFieldParent.scrollIntoView({
                behavior: "smooth",
                block: "center",
            });
        }
    };

    const submitHandler = async (event: React.MouseEvent<HTMLButtonElement>) => {
        event.preventDefault();

        if (!isCreateNewCustomerPage) {
            const isCaptchaValid = await validateReCaptcha({ location: "ContactUs", recaptchaRef });
            if (!isCaptchaValid) {
                return;
            }
        }

        if (!isSubmitted) {
            setIsSubmitted(true);
        }

        setSubmitClicked(true);
        setButtonTransition(true);

        if (!validateSubmitEnabled()) {
            setFormErrors(formErrors);
            setTimeout(() => {
                scrollToFirstFormError();
            }, 50);
            setSubmitClicked(false);
            setButtonTransition(false);
            return false;
        }

        const selectedDept = depState && depState.description;
        const selectedCountry = country && country.id;
        const selectedbtState = billToState && billToState.id ? billToState && billToState.id : "";
        // const selectedbtState = billToState && billToState.id ? billToState && billToState.id : "";

        const selectedStCountry = shipToCountry && (shipToCountry as CountryModel)!.id;
        const selectedStState =
            shipToState && (shipToState as StateModel)!.id ? shipToState && (shipToState as StateModel)!.id : "";
        const IsSalesPersonNewCustomer = !!isCreateNewCustomerPage;

        props.addAccount({
            email,
            userName,
            accountNumber: "",
            firstName,
            lastName,
            phone,
            password,
            IsCustomerNumberProvided: customerNumberProvided,
            companyName,
            address1,
            address2,
            city,
            postalCode,
            IsShipToSameAsBilling,
            address1ShipTo,
            address2ShipTo,
            companyNameShipTo,
            cityShipTo,
            zipShipTo,
            IsCreditAccount,
            // billToSelectedCountry,
            // billToSelectedState,
            // shipToSelectedCountry,
            // shipToSelectedState,
            businessStartDate,
            organizationStructure,
            stateDateIncorporated,
            companyOperationalTime,
            principalActivity,
            IsCompanyNameChanged,
            formerName,
            IsPastBought,
            pastBuyerName,
            creditLimit,
            IsSalesTaxExempt,
            apContact,
            apContactEmail,
            bankName,
            bankAccount,
            bankAddress,
            bankPhone,
            bankFax,
            businessRefCompName1,
            businessRefName1,
            businessRefTitle1,
            businessRefAddress1,
            businessRefPhone1,
            businessRefFax1,
            businessRefCompName2,
            businessRefName2,
            businessRefTitle2,
            businessRefAddress2,
            businessRefPhone2,
            businessRefFax2,
            IsBankrupt,
            IsSuitFiled,
            IsUpsAccount,
            upsAccount,
            receivingHours,
            IsTerms,
            invEmailText,
            invFaxNumberText,
            suitFiledText,
            IsBankruptText,
            selectedDept,
            selectedCountry,
            selectedbtState,
            selectedStCountry,
            selectedStState,
            phoneShipTo,
            IsSalesPersonNewCustomer,
            date: new Date(),
            onSuccess: () => {
                setButtonTransition(false);
                onSuccessHandler();
            },
            onError: (error: any) => {
                setSubmitClicked(false);
                setButtonTransition(false);
                let errorNumber = error.split(", Message: ")[0].split("Error Code: ")[1];
                let errorMessageText = error.split("Message: ")[1];
                if (!errorMessageText) {
                    errorNumber = "";
                    errorMessageText = error;
                }
                setLoadingState(false);
                if (errorNumber === "533") {
                    setshowExistEmail(true);
                    errorMessageText = "";
                } else if (errorNumber === "454") {
                    setshowExistEmail(false);
                    errorMessageText = siteMessageWithCustomParserOptions(
                        "CreateNewAccountInfo_PostalCode_Error_Message",
                        parserOptions,
                    );
                } else if (errorNumber === "708") {
                    setshowExistEmail(false);
                    errorMessageText = siteMessageWithCustomParserOptions(
                        "CreateNewAccountInfo_Contact_Information",
                        parserOptions,
                        errorMessageText,
                    );
                } else {
                    setshowExistEmail(false);
                }

                setErrorMessage(errorMessageText);
            },
            isSubscribed: false,
        });
    };

    const onSuccessHandler = () => {
        setErrorMessage("");
        setshowExistEmail(false);
        setSubmitClicked(false);
        toasterContext.addToast({ body: translate("Account created successfully!"), messageType: "success" });
        if (isCreateNewCustomerPage) {
            resetFormHandler();
        } else {
            setTimeout(() => {
                props.signIn({
                    userName,
                    password,
                    rememberMe: false,
                    returnUrl,
                });
            }, 500);
        }
        const dataLayer = (window as any).dataLayer || [];
        if (dataLayer) {
            dataLayer.push({ ecommerce: null });
            dataLayer.push({
                event: "sign_up",
                registration_type: "New Customer Account",
            });
        }
    };

    const resetFormHandler = () => {
        setFormErrors(intialErrorFormState);
        setEmail("");
        setUserName("");
        setFirstName("");
        setLastName("");
        setPhone("");
        setCompanyName("");
        setCustomerAddress1("");
        setCustomerAddress2("");
        setCity("");
        setPostalCode("");
        setIsShipToSameAsBillTo(true);
        setShipToAddress1("");
        setShipToAddress2("");
        setShipToCompanyName("");
        setShipToCity("");
        setShipToPostalCode("");
        setDepState(depWithoutOther && depWithoutOther[0]);
        setCountry(selCountry);
        setBillToState(selCountry && selCountry.states ? selCountry.states[0] : undefined);
        setShipToCountry(selCountry);
        setShipToState(selCountry && selCountry.states ? selCountry.states[0] : undefined);
        setShipToPhone("");
    };

    const organizationStructureHandler = (orgnizationType: string) => {
        setOrganizationStructure(orgnizationType);
    };

    const firstNameChangeHandler = (input: HTMLInputElement) => {
        validateFirstName(input.value);
        setFirstName(input.value);
    };

    const validateFirstName = (name: string) => {
        const errorMessage = !name ? firstNameErrorMsg : "";
        setFirstNameError(errorMessage);
        return !errorMessage;
    };

    const companyNameHandler = (cName: string) => {
        validateCompanyName(cName);
        setCompanyName(cName);
    };

    const validateCompanyName = (name: string) => {
        const errorMessage = !name ? companyNameErrorMsg : "";
        setCompanyError(errorMessage);
        return !errorMessage;
    };

    const lastNameChangeHandler = (name: string) => {
        validateLastName(name);
        setLastName(name);
    };

    const validateLastName = (name: string) => {
        const errorMessage = !name ? lastNameErrorMsg : "";
        setLastNameError(errorMessage);
        return !errorMessage;
    };

    const phoneChangeHandler = (value: string) => {
        const phoneDigits = value.replace(/\D/g, "");
        const isNorthAmericanCountry = country?.abbreviation === "US" || country?.abbreviation === "CA";
        setPhone(isNorthAmericanCountry ? formatPhoneNumber(phoneDigits) : phoneDigits);
        validatePhone(phoneDigits, isNorthAmericanCountry);
    };
    const validatePhone = (value: string, isNorthAmericanCountry = true) => {
        const errorMessage =
            !value
                ? isNorthAmericanCountry
                    ? phoneErrorMsg
                    : ""
                                : isNorthAmericanCountry && value.length !== 10
                  ? validPhoneMsg
                  : "";
        setPhoneError(errorMessage);
        return !errorMessage;
    };

    const customerAddress1Handler = (name: string) => {
        setCustomerAddress1(name);
        if (IsShipToSameAsBilling) {
            setShipToAddress1(name);
        }
        validateAddress1(name);
    };

    const validateAddress1 = (name: string) => {
        const errorMessage = !name ? address1ErrorMsg : "";
        setCustomerAddress1Error(errorMessage);
        return !errorMessage;
    };

    const customerAddress2Handler = (address2: string) => {
        setCustomerAddress2(address2);
        if (IsShipToSameAsBilling) {
            setShipToAddress2(address2);
        }
    };
    const postalCodeHandler = (input: HTMLInputElement) => {
        setPostalCode(input.value);
        if (IsShipToSameAsBilling) {
            setShipToPostalCode(input.value);
        }
        validatePostalCode(input);
    };

    const validatePostalCode = (input: HTMLInputElement) => {
        const errorMessage = !input.value ? postalCodeErrorMsg : "";
        setPostalCodeError(errorMessage);
        return !errorMessage;
    };

    const cityHandler = (input: HTMLInputElement) => {
        setCity(input.value);
        if (IsShipToSameAsBilling) {
            setShipToCity(input.value);
        }
        validateCity(input);
    };
    const validateCity = (input: HTMLInputElement) => {
        let errorMessage: any = "";
        if (country?.abbreviation === "US" && input.value.indexOf(",") !== -1) {
            errorMessage = shipToCityValidErrorMsg;
        } else if (!input.value) {
            errorMessage = cityErrorMsg;
        }
        setCityError(errorMessage);
        return !errorMessage;
    };

    const componentStyles: MessageFilterStyles = styles.messageFilter || {};

    const stateDateIncorporatedHandler = (input: HTMLInputElement) => {
        setStateDateIncorporated(input.value);
    };

    const companyOperationalTimeHandler = (input: HTMLInputElement) => {
        setCompanyOperationalTime(input.value);
        validateHandlerForCredit(input);
    };

    const principalActivityHandler = (input: HTMLInputElement) => {
        setPrincipalActivity(input.value);
        validateHandlerForCredit(input);
    };

    const isCompanyNameChangedHandler = (IsCompanyNameChanged: string) => {
        setIsCompanyNameChanged(IsCompanyNameChanged);
        yesNoQuestionsValidationHandler(IsCompanyNameChanged, ["formerName"]);
    };

    const formerNameHandler = (formerName: string) => {
        setFormerName(formerName);
        yesNoQuestionsValidationHandler(IsCompanyNameChanged, ["formerName"]);
    };

    const isPastBoughtHandler = (IsPastBought: string) => {
        setIsPastBought(IsPastBought);
        yesNoQuestionsValidationHandler(IsPastBought, ["pastBuyerName"]);
    };

    const pastBuyerNameHandler = (name: string) => {
        setPastBuyerName(name);
        yesNoQuestionsValidationHandler(IsPastBought, ["pastBuyerName"]);
    };

    const yesNoQuestionsValidationHandler = (answer: string, fieldnames: string[]) => {
        for (const key of fieldnames) {
            const element: HTMLSelectElement | HTMLInputElement | null = document.querySelector(`[name="${key}"]`);
            if (element != null) {
                if (answer === "Yes") {
                    validateHandlerForCredit(element);
                } else {
                    validationRemoveHandler(key);
                }
            }
        }
    };
    const creditLimitHandler = (limit: string) => {
        setCreditLimit(limit);
    };

    const isSalesTaxExemptHandler = (IsSalesTaxExempt: string) => {
        setIsSalesTaxExempt(IsSalesTaxExempt);
    };

    const apContactHandler = (input: HTMLInputElement) => {
        setApContact(input.value);
        validateHandlerForCredit(input);
    };

    const apContactEmailHandler = (email: string) => {
        setApContactEmail(email);
    };

    const brcNameHandler = (input: HTMLInputElement) => {
        setBrcFirstname(input.value);
        validateHandlerForCredit(input);
    };

    const brcAccountHandler = (input: HTMLInputElement) => {
        setBrcAccount(input.value);
        validateHandlerForCredit(input);
    };

    const brcPhoneNumberHandler = (input: HTMLInputElement) => {
        setBrcPhoneNumber(formatPhoneNumber(input.value));
        validateHandlerForCredit(input);
    };

    const brcAddressHandler = (input: HTMLInputElement) => {
        setBrcAddress(input.value);
        validateHandlerForCredit(input);
    };

    const brcFaxHandler = (input: HTMLInputElement) => {
        setBrcFax(formatPhoneNumber(input.value));
        validateHandlerForCredit(input);
    };

    const businessRefCompName1Handler = (input: HTMLInputElement) => {
        setBusinessRefCompName1(input.value);
        validateHandlerForCredit(input);
    };

    const businessRefName1Handler = (input: HTMLInputElement) => {
        setBusinessRefName1(input.value);
        validateHandlerForCredit(input);
    };

    const businessRefTitle1Handler = (title: string) => {
        setBusinessRefTitle1(title);
    };

    const businessRefAddress1Handler = (input: HTMLInputElement) => {
        setBusinessRefAddress1(input.value);
        validateHandlerForCredit(input);
    };

    const businessRefPhone1Handler = (input: HTMLInputElement) => {
        setBusinessRefPhone1(formatPhoneNumber(input.value));
        validateHandlerForCredit(input);
    };

    const businessRefFax1Handler = (input: HTMLInputElement) => {
        setBusinessRefFax1(formatPhoneNumber(input.value));
        validateHandlerForCredit(input);
    };

    const businessRefCompName2Handler = (input: HTMLInputElement) => {
        setBusinessRefCompName2(input.value);
        validateHandlerForCredit(input);
    };

    const businessRefName2Handler = (input: HTMLInputElement) => {
        setBusinessRefName2(input.value);
        validateHandlerForCredit(input);
    };

    const businessRefTitle2Handler = (title: string) => {
        setBusinessRefTitle2(title);
    };

    const businessRefAddress2Handler = (input: HTMLInputElement) => {
        setBusinessRefAddress2(input.value);
        validateHandlerForCredit(input);
    };

    const businessRefPhone2Handler = (input: HTMLInputElement) => {
        setBusinessRefPhone2(formatPhoneNumber(input.value));
        validateHandlerForCredit(input);
    };

    const businessRefFax2Handler = (input: HTMLInputElement) => {
        setBusinessRefFax2(formatPhoneNumber(input.value));
        validateHandlerForCredit(input);
    };

    const receivingHoursHandler = (input: HTMLInputElement) => {
        setReceivingHours(input.value);
        validateHandlerForCredit(input);
    };

    const isTermsHandler = (input: HTMLInputElement) => {
        setIsTerms(input.value);
        validateHandlerForCredit(input);
    };

    const shipToAddress1Handler = (name: string) => {
        validateShipToAddress1(name);
        setShipToAddress1(name);
    };

    const validateShipToAddress1 = (name: string) => {
        const errorMessage = !name ? shipToAddress1ErrorMsg : "";
        setShipToCustomerAddress1Error(errorMessage);
        return !errorMessage;
    };

    const shipToAddress2Handler = (address2: string) => {
        setShipToAddress2(address2);
    };

    const shipToCityHandler = (input: HTMLInputElement) => {
        validateShipToCity(input);
        setShipToCity(input.value);
    };

    const validateShipToCity = (input: HTMLInputElement) => {
        let errorMessage: any = "";
        if (country?.abbreviation === "US" && input.value.indexOf(",") !== -1) {
            errorMessage = shipToCityValidErrorMsg;
        } else if (!input.value) {
            errorMessage = shipToCityErrorMsg;
        }
        setshiToCityError(errorMessage);
        return !errorMessage;
    };

    const shipToPostalCodeHandler = (input: HTMLInputElement) => {
        validateShiipingPostalCode(input);
        setShipToPostalCode(input.value);
    };
    const validateShiipingPostalCode = (input: HTMLInputElement) => {
        const errorMessage = !input.value ? shippingPostalCodeErrorMsg : "";
        setShippingPostaCodeError(errorMessage);
        return !errorMessage;
    };

    const shipToCompanyNameHandler = (cName: string) => {
        setShipToCompanyName(cName);
    };

    const shipToPhoneHandler = (value: string) => {
        const phoneDigits = value.replace(/\D/g, "");
        const isNorthAmericanCountry =
            shipToCountry?.abbreviation === "US" || shipToCountry?.abbreviation === "CA";
        setShipToPhone(isNorthAmericanCountry ? formatPhoneNumber(phoneDigits) : phoneDigits);
        validateShiToPhone(phoneDigits, isNorthAmericanCountry);
    };

    const validateShiToPhone = (value: string, isNorthAmericanCountry = true) => {
        const errorMessage =
            !value
                ? isNorthAmericanCountry
                    ? shipToPhoneErrorMsg
                    : ""
                                : isNorthAmericanCountry && value.length !== 10
                  ? shipToValidPhoneMsg
                  : "";
        setShipToPhoneError(errorMessage);
        return !errorMessage;
    };

    const handleInvoicesBeSent = (input: HTMLInputElement) => {
        formErrorsForCredit.invEmailText = "";
        formErrorsForCredit.invFaxText = "";
        setInvoicesBeSent(input.value);
        InvoicesBeSent === "e-mail" ? setInvFaxNumber("") : InvoicesBeSent === "fax number" ? setInvEmail("") : "";
        input.value === "Us Postal email"
            ? setUSPostalMail("** Billing Address will be used **")
            : setIsCreditFormButtonDisabled(true);
        if (input.value === "Us Postal email") {
            delete formErrorsForCredit["invFaxText" as keyof FormErrorsStateType];
            delete formErrorsForCredit["invEmailText" as keyof FormErrorsStateType];
            setIsCreditFormButtonDisabled(validateSubmitDisabled(formErrorsForCredit));
        } else if (input.value === "e-mail") {
            delete formErrorsForCredit["invFaxText" as keyof FormErrorsStateType];
            setIsCreditFormButtonDisabled(validateSubmitDisabled(formErrorsForCredit));
        } else {
            delete formErrorsForCredit["invEmailText" as keyof FormErrorsStateType];
            setIsCreditFormButtonDisabled(validateSubmitDisabled(formErrorsForCredit));
        }
        //  setIsCreditFormButtonDisabled(true);
    };

    const invFaxNumberHandler = (input: HTMLInputElement) => {
        setInvFaxNumber(formatPhoneNumber(input.value));
        setInvFlag("Fax");
        validateHandlerForCredit(input);
    };

    const invEmailHandler = (input: HTMLInputElement) => {
        setInvEmail(input.value);
        setInvFlag("Email");
        validateHandlerForCredit(input);
    };

    const isBankruptTextHandler = (text: string) => {
        setIsBankruptText(text);
        yesNoQuestionsValidationHandler(IsBankrupt, ["IsBankruptText"]);
    };

    const suitFiledTextHandler = (text: string) => {
        setSuitFiledText(text);
        yesNoQuestionsValidationHandler(IsSuitFiled, ["suitFiledText"]);
    };
    const isBankruptHandler = (IsBankrupt: string) => {
        setIsBankrupt(IsBankrupt);
        yesNoQuestionsValidationHandler(IsBankrupt, ["IsBankruptText"]);
    };

    const isSuitFiledHandler = (IsSuitFiled: string) => {
        setIsSuitFiled(IsSuitFiled);
        yesNoQuestionsValidationHandler(IsSuitFiled, ["suitFiledText"]);
    };

    const isUpsAccountHandler = (IsUpsAccount: string) => {
        setIsUpsAccount(IsUpsAccount);
        yesNoQuestionsValidationHandler(IsUpsAccount, ["upsAccount"]);
    };

    const upsAccountHandler = (flag: string) => {
        setUpsAccount(flag);
        yesNoQuestionsValidationHandler(IsUpsAccount, ["upsAccount"]);
    };

    const setShippingAddressSameAsBillingAddressOnLoad = (isChecked: boolean) => {
        setIsShipToSameAsBillTo(isChecked);
        const shippingErrors = [
            "address1ShipTo",
            "cityShipTo",
            "zipShipTo",
            "SelectShipToState",
            "SelectShipToCountry",
            "phoneShipTo",
        ];
        setShipToAddress1(address1);
        setShipToAddress2(address2);
        setShipToCity(city);
        setShipToCountry(country);
        setShipToState(billToState);
        setShipToPostalCode(postalCode);
        shippingErrors.forEach(inputName => {
            delete formErrors[inputName as keyof FormErrorsStateType];
            setFormErrors(formErrors);
        });
        setIsButtonDisabled(validateSubmitDisabled(formErrors));
    };

    const setShippingAddressSameAsBillingAddress = (isChecked: boolean) => {
        setIsShipToSameAsBillTo(isChecked);
        const shippingErrors = [
            "address1ShipTo",
            "cityShipTo",
            "zipShipTo",
            "SelectShipToState",
            "SelectShipToCountry",
            "phoneShipTo",
        ];
        if (isChecked) {
            setShipToAddress1(address1);
            setShipToAddress2(address2);
            setShipToCity(city);
            setShipToCountry(country);
            setShipToState(billToState);
            setShipToPostalCode(postalCode);
            shippingErrors.forEach(inputName => {
                delete formErrors[inputName as keyof FormErrorsStateType];
                setFormErrors(formErrors);
            });
        } else {
            setShipToAddress1("");
            setShipToAddress2("");
            setShipToCity("");
            setShipToPhone("");
            setShipToPostalCode("");
            const selectStateEl: HTMLSelectElement | null = document.querySelector('[name="SelectShipToState"]');
            if (selectStateEl) {
                validateHandler(selectStateEl);
            }
            shippingErrors.forEach(inputName => {
                if (!(inputName === "SelectShipToState" || inputName === "SelectShipToCountry")) {
                    setFormErrors(prevState => {
                        return {
                            ...prevState,
                            [inputName]: "",
                        };
                    });
                }
            });
        }
        setIsButtonDisabled(validateSubmitDisabled(formErrors));
    };

    const handleDepartmentChange = (event: React.ChangeEvent<HTMLSelectElement>) => {
        const selectedDepartment = props.departments!.find(c => c.id === event.currentTarget.value)!;
        setDepState(selectedDepartment);
    };
    const handleCountryChange = (event: React.ChangeEvent<HTMLSelectElement>) => {
        const countryLookup = props.countries!.find(c => c.id === event.currentTarget.value)!;
        setCountry(countryLookup);
        setPhone("");
        validateHandler(event.currentTarget);
        if (countryLookup.abbreviation === "US" && city.indexOf(",") !== -1) {
            setCityError(shipToCityValidErrorMsg);
        }
        if (IsShipToSameAsBilling) {
            setShipToCountry(countryLookup);
        }
        if (!(countryLookup && countryLookup.states && countryLookup.states.length > 0)) {
            const stSelectedState: StateModel | undefined = undefined;
            setBillToState(stSelectedState);
            setShipToState(stSelectedState);
            delete formErrors["selectState" as keyof FormErrorsStateType];
            setFormErrors(removeKey(formErrors, "selectState"));
            delete formErrors["SelectShipToState" as keyof FormErrorsStateType];
            setFormErrors(removeKey(formErrors, "SelectShipToState"));
            if (!IsCreditAccount) {
                setIsButtonDisabled(validateSubmitDisabled(formErrors));
            }
        }
        // need to check that if user is changing his country then state's value should get refresh
    };

    const handleStateChange = (event: React.ChangeEvent<HTMLSelectElement>) => {
        const selectedState: StateModel | undefined = country!.states!.find(s => s.id === event.currentTarget.value);
        setBillToState(selectedState);
        validateHandler(event.currentTarget);
        if (IsShipToSameAsBilling) {
            setShipToState(selectedState);
        }
    };
    const handleShipToCountryChange = (event: React.ChangeEvent<HTMLSelectElement>) => {
        const stCountryLookup = props.countries!.find(c => c.id === event.currentTarget.value)!;
        setShipToCountry(stCountryLookup);
        setShipToPhone("");
        validateHandler(event.currentTarget);
        if (stCountryLookup.abbreviation === "US" && cityShipTo.indexOf(",") !== -1) {
            setshiToCityError(shipToCityValidErrorMsg);
        }
        if (!(stCountryLookup && stCountryLookup.states && stCountryLookup.states.length > 0)) {
            const stSelectedState: StateModel | undefined = undefined;
            setShipToState(stSelectedState);
            delete formErrors["SelectShipToState" as keyof FormErrorsStateType];
            setFormErrors(removeKey(formErrors, "SelectShipToState"));
            if (!IsCreditAccount) {
                setIsButtonDisabled(validateSubmitDisabled(formErrors));
            }
        }
        // need to check that if user is changing his country then state's value should get refresh
    };

    const handleShipToStateChange = (event: React.ChangeEvent<HTMLSelectElement>) => {
        const stSelectedState: StateModel | undefined = shipToCountry!.states!.find(
            s => s.id === event.currentTarget.value,
        )!;
        setShipToState(stSelectedState);
        validateHandler(event.currentTarget);
    };

    const creditAccountHandler = (value: boolean) => {
        if (value) {
            if (!validateSubmitDisabled(formErrors)) {
                setIsButtonDisabled(true);
                setIsCreditAccount(value);
                setIsCreditAccountErrorMsg(false);
            } else {
                setIsCreditAccountErrorMsg(true);
                window.scrollTo(0, 0);
            }
        } else if (!validateSubmitDisabled(formErrors)) {
            setIsButtonDisabled(false);
            setIsCreditAccount(value);
            setIsCreditAccountErrorMsg(false);
        } else {
            setIsCreditAccountErrorMsg(true);
            window.scrollTo(0, 0);
        }
    };

    const businessStartDateHandler = (input: HTMLInputElement) => {
        setBusinessStartDate(input.value);
    };

    const USflag = defaultCountry?.name === "United States";

    return (
        <LoadingOverlay loading={showLoadingState} spinnerProps={{ color: "primary" }}>
            <StyledWrapper {...styles.wrapper}>
                <form autoComplete="off">
                    <StyledWrapper {...CreateAccountExistingFormStyles.formWrapper}>
                        <StyledWrapper
                            {...styles.errorMessageStyle}
                            style={{ display: IsCreditAccountErrorMsg ? "block" : "none" }}
                        >
                            Please fill out all the required fields.
                        </StyledWrapper>

                        <Typography as="p" {...CreateAccountExistingFormStyles.errorIndication}>
                            <StyledSpan {...CreateAccountExistingFormStyles.errorColor}>*</StyledSpan> Indicates a
                            required field
                        </Typography>

                        <GridContainer {...styles.mainGridContainer} {...CreateAccountExistingFormStyles.leftPadding}>
                            {/* Company Details */}
                            <GridItem {...CreateAccountExistingFormStyles.mainGridItem}>
                                <StyledWrapper {...CreateAccountExistingFormStyles.sectionHeading}>
                                    New Customer Registration
                                </StyledWrapper>
                                <GridContainer>
                                    <GridItem {...CreateAccountExistingFormStyles.halfGridItem}>
                                        <StyledWrapper {...CreateAccountExistingFormStyles.inputStyle}>
                                            <TextField
                                                {...styles.userNameTextField}
                                                label={translate("Company Name *")}
                                                value={companyName}
                                                data-test-selector="createAccount_companyName"
                                                onChange={e => companyNameHandler(e.currentTarget.value)}
                                                error={isSubmitted && companyError}
                                            />
                                        </StyledWrapper>
                                    </GridItem>
                                    <GridItem {...CreateAccountExistingFormStyles.halfGridItem}>
                                        <StyledWrapper {...CreateAccountExistingFormStyles.inputStyle}>
                                            <Select
                                                {...styles.departmentSelect}
                                                label={translate("Department")}
                                                value={
                                                    (depState && depState.id) ||
                                                    (props.departments && props.departments[0].id)
                                                }
                                                labelPosition="top"
                                                onChange={e => handleDepartmentChange(e)}
                                            >
                                                {depWithoutOther &&
                                                    depWithoutOther.map(dept => (
                                                        <option key={dept?.id} value={dept?.id}>
                                                            {dept?.description}
                                                        </option>
                                                    ))}
                                            </Select>
                                            <Tooltip
                                                {...CreateAccountExistingFormStyles.toolTipMessage}
                                                text={
                                                    siteMessage(
                                                        'Choose a department from the list that best describes your role within the company. If you are not part of a company, select "personal"',
                                                    ) as string
                                                }
                                            />
                                        </StyledWrapper>
                                    </GridItem>
                                    <GridItem {...CreateAccountExistingFormStyles.halfGridItem}>
                                        <StyledWrapper {...CreateAccountExistingFormStyles.inputStyle}>
                                            <TextField
                                                {...styles.userNameTextField}
                                                label={translate("First Name *")}
                                                value={firstName}
                                                data-test-selector="createAccount_firstName"
                                                onChange={e => firstNameChangeHandler(e.currentTarget)}
                                                error={isSubmitted && firstNameError}
                                                name="firstName"
                                                iconProps={{
                                                    color: "danger",
                                                    src: formErrors.firstName ? AlertTriangle : undefined,
                                                }}
                                            />
                                        </StyledWrapper>
                                    </GridItem>
                                    <GridItem {...CreateAccountExistingFormStyles.halfGridItem}>
                                        <StyledWrapper {...CreateAccountExistingFormStyles.inputStyle}>
                                            <TextField
                                                {...styles.userNameTextField}
                                                label={translate("Last Name *")}
                                                value={lastName}
                                                data-test-selector="createAccount_lastName"
                                                onChange={e => lastNameChangeHandler(e.currentTarget.value)}
                                                error={isSubmitted && lastNameError}
                                                iconProps={{
                                                    color: "danger",
                                                    src: formErrors.lastName ? AlertTriangle : undefined,
                                                }}
                                                name="lastName"
                                            />
                                        </StyledWrapper>
                                    </GridItem>
                                    <GridItem {...CreateAccountExistingFormStyles.halfGridItem}>
                                        <StyledWrapper {...CreateAccountExistingFormStyles.inputStyle}>
                                            <TextField
                                                {...styles.emailTextField}
                                                type="email"
                                                label={translate("User Name (Email) *")}
                                                onChange={e => emailChangeHandler(e.currentTarget)}
                                                error={isSubmitted && emailError}
                                                iconProps={{
                                                    color: "danger",
                                                    src: formErrors.email ? AlertTriangle : undefined,
                                                }}
                                                value={email}
                                                data-test-selector="createAccount_email"
                                                name="email"
                                            />
                                            <Tooltip
                                                {...CreateAccountExistingFormStyles.toolTipMessage}
                                                text={
                                                    siteMessage(
                                                        "Your E-Mail Address will serve as your User ID when you Login",
                                                    ) as string
                                                }
                                            />
                                        </StyledWrapper>
                                    </GridItem>
                                    <GridItem {...CreateAccountExistingFormStyles.halfGridItem}>
                                        <StyledWrapper {...CreateAccountExistingFormStyles.inputStyle}>
                                            <TextField
                                                {...styles.userNameTextField}
                                                type="tel"
                                                label={translate("Phone Number *")}
                                                autoComplete="autocomplete_off_randString"
                                                value={phone}
                                                data-test-selector="createAccount_shipTophoneNumber"
                                                onChange={e => phoneChangeHandler(e.currentTarget.value)}
                                                error={isSubmitted && phoneError}
                                                iconProps={{
                                                    color: "danger",
                                                    src: formErrors.phone ? AlertTriangle : undefined,
                                                }}
                                                name="phone"
                                            />
                                            <Tooltip
                                                {...CreateAccountExistingFormStyles.toolTipMessage}
                                                text={
                                                    siteMessage(
                                                        "Best phone number to reach you for business-related questions. Please enter only numbers. No dashes '-' or other characters are accepted.",
                                                    ) as string
                                                }
                                            />
                                        </StyledWrapper>
                                    </GridItem>
                                    {!isCreateNewCustomerPage && (
                                        <>
                                            <GridItem {...CreateAccountExistingFormStyles.halfGridItem}>
                                                <StyledWrapper {...CreateAccountExistingFormStyles.inputStyle}>
                                                    <TextField
                                                        id="password"
                                                        {...styles.passwordTextField}
                                                        type={showPassword ? undefined : "password"}
                                                        label={translate("Password *")}
                                                        value={password}
                                                        onChange={e => passwordChangeHandler(e.currentTarget)}
                                                        iconProps={{
                                                            ...styles.passwordIcon,
                                                            src: showPassword ? EyeOff : Eye,
                                                        }}
                                                        error={
                                                            isSubmitted && password === ""
                                                                ? passwordErrorMsg
                                                                : formErrors.password
                                                        }
                                                        iconClickableProps={{
                                                            onClick: () => {
                                                                setShowPassword(!showPassword);
                                                            },
                                                        }}
                                                        data-test-selector="createAccount_password"
                                                        name="password"
                                                    />
                                                    <Tooltip
                                                        {...CreateAccountExistingFormStyles.toolTipMessagePassword}
                                                        text={
                                                            siteMessage(
                                                                'Password must be at least 8 characters long and include : <br/> - an uppercase character <br/> - a lowercase character <br/> - a number <br/> - a non-alphanumeric character (but not "%", "?", "&" or ":") ',
                                                            ) as string
                                                        }
                                                    />
                                                </StyledWrapper>
                                            </GridItem>
                                            <GridItem {...CreateAccountExistingFormStyles.halfGridItem}>
                                                <StyledWrapper {...CreateAccountExistingFormStyles.inputStyle}>
                                                    <TextField
                                                        id="confirm-password"
                                                        {...styles.confirmPasswordTextField}
                                                        type={showConfirmPassword ? undefined : "password"}
                                                        label={translate("Confirm Password *")}
                                                        value={confirmPassword}
                                                        onChange={e => confirmPasswordChangeHandler(e.currentTarget)}
                                                        iconProps={{
                                                            ...styles.confirmPasswordIcon,
                                                            src: showConfirmPassword ? EyeOff : Eye,
                                                        }}
                                                        error={
                                                            isSubmitted && confirmPassword === ""
                                                                ? confirmPasswordErrorMsg
                                                                : formErrors.confirmPassword
                                                        }
                                                        iconClickableProps={{
                                                            onClick: () => {
                                                                setShowConfirmPassword(!showConfirmPassword);
                                                            },
                                                        }}
                                                        data-test-selector="createAccount_confirmPassword"
                                                        name="confirmPassword"
                                                    />
                                                </StyledWrapper>
                                            </GridItem>
                                        </>
                                    )}
                                </GridContainer>
                            </GridItem>

                            {/* Billing Address */}
                            <GridItem {...CreateAccountExistingFormStyles.mainGridItem}>
                                <StyledWrapper {...CreateAccountExistingFormStyles.sectionHeading}>
                                    Billing Address
                                </StyledWrapper>
                                <GridContainer>
                                    <GridItem {...CreateAccountExistingFormStyles.halfGridItem}>
                                        <StyledWrapper {...CreateAccountExistingFormStyles.inputStyle}>
                                            <TextField
                                                {...styles.userNameTextField}
                                                label={translate("Address1 *")}
                                                value={address1}
                                                data-test-selector="createAccount_address1"
                                                onChange={e => customerAddress1Handler(e.currentTarget.value)}
                                                error={isSubmitted && address1Error}
                                                iconProps={{
                                                    color: "danger",
                                                    src: formErrors.address1 ? AlertTriangle : undefined,
                                                }}
                                                name="address1"
                                            />
                                            {/* <Tooltip
                                    {...CreateAccountExistingFormStyles.toolTipMessage}
                                    text={
                                        siteMessage(
                                            "Please provide your mailing address. You will be able to add multiple ship-to location and separate billing addresses later.",
                                        ) as string
                                    }
                                    
                                /> */}
                                        </StyledWrapper>
                                    </GridItem>
                                    <GridItem {...CreateAccountExistingFormStyles.halfGridItem}>
                                        <StyledWrapper {...CreateAccountExistingFormStyles.inputStyle}>
                                            <TextField
                                                {...styles.userNameTextField}
                                                label={translate("Address 2")}
                                                value={address2}
                                                data-test-selector="createAccount_address2"
                                                onChange={e => customerAddress2Handler(e.currentTarget.value)}
                                            />
                                        </StyledWrapper>
                                    </GridItem>
                                    <GridItem {...CreateAccountExistingFormStyles.halfGridItem}>
                                        <StyledWrapper {...CreateAccountExistingFormStyles.inputStyle}>
                                            <TextField
                                                {...styles.userNameTextField}
                                                label={translate("City *")}
                                                value={city}
                                                data-test-selector="createAccount_city"
                                                onChange={e => cityHandler(e.currentTarget)}
                                                error={isSubmitted && cityError}
                                                iconProps={{
                                                    color: "danger",
                                                    src: formErrors.city ? AlertTriangle : undefined,
                                                }}
                                                name="city"
                                            />
                                        </StyledWrapper>
                                    </GridItem>
                                    {defaultCountry &&
                                        defaultCountry.states &&
                                        defaultCountry.states.length > 0 &&
                                        props.countries && (
                                            <GridItem {...CreateAccountExistingFormStyles.halfGridItem}>
                                                <StyledWrapper {...CreateAccountExistingFormStyles.inputStyle}>
                                                    <Select
                                                        {...styles.departmentSelect}
                                                        label={translate("State")}
                                                        value={
                                                            billToState && billToState.id
                                                            // (country && country.states && country.states[0] && country.states[0].id)
                                                        }
                                                        labelPosition="top"
                                                        name="selectState"
                                                        onChange={e => handleStateChange(e)}
                                                        error={!!formErrors.selectState && formErrors.selectState}
                                                    >
                                                        <option value="">{translate("Select State")}</option>
                                                        {
                                                            !USflag
                                                                ? defaultCountry &&
                                                                  defaultCountry.states &&
                                                                  defaultCountry.states.map(btState => (
                                                                      <option key={btState.id} value={btState.id}>
                                                                          {btState.name}
                                                                      </option>
                                                                  ))
                                                                : rearrangedStates
                                                                      .filter(btState => btState)
                                                                      .map(btState => (
                                                                          <option key={btState?.id} value={btState?.id}>
                                                                              {btState?.name}
                                                                          </option>
                                                                      ))
                                                            // rearrangedStates.map(btState => (
                                                        }
                                                    </Select>
                                                </StyledWrapper>
                                            </GridItem>
                                        )}

                                    <GridItem {...CreateAccountExistingFormStyles.halfGridItem}>
                                        <StyledWrapper {...CreateAccountExistingFormStyles.inputStyle}>
                                            <TextField
                                                {...styles.userNameTextField}
                                                label={translate("Postal Code *")}
                                                value={postalCode}
                                                data-test-selector="createAccount_postalcode"
                                                onChange={e => postalCodeHandler(e.currentTarget)}
                                                error={isSubmitted && postalCodeError}
                                                iconProps={{
                                                    color: "danger",
                                                    src: formErrors.zipcode ? AlertTriangle : undefined,
                                                }}
                                                name="zipcode"
                                            />
                                        </StyledWrapper>
                                    </GridItem>
                                    <GridItem {...CreateAccountExistingFormStyles.halfGridItem}>
                                        <StyledWrapper {...CreateAccountExistingFormStyles.inputStyle}>
                                            <Select
                                                {...styles.departmentSelect}
                                                label={translate("Country")}
                                                value={country && country.id}
                                                labelPosition="top"
                                                name="selectCountry"
                                                onChange={e => handleCountryChange(e)}
                                                onBlur={e => onBlurValidationHandler(e.currentTarget)}
                                                error={!!formErrors.selectCountry && formErrors.selectCountry}
                                            >
                                                {props?.countries &&
                                                    props?.countries?.map(country => (
                                                        <option
                                                            key={country.id}
                                                            value={country.id}
                                                            selected={!!country}
                                                        >
                                                            {country.name}
                                                        </option>
                                                    ))}
                                            </Select>
                                        </StyledWrapper>
                                    </GridItem>
                                </GridContainer>
                            </GridItem>

                            {/* Shipping Address */}
                            <StyledWrapper {...styles.shipToBillToCheck}>
                                <CheckboxGroup {...styles.checkboxAlignment}>
                                    <Checkbox
                                        onChange={(e, value) => setShippingAddressSameAsBillingAddress(value)}
                                        checked={IsShipToSameAsBilling}
                                        data-test-selector="createAccount_Subscription"
                                    >
                                        The Shipping Address is the same as the Billing Address
                                    </Checkbox>
                                </CheckboxGroup>
                            </StyledWrapper>

                            {!isCreateNewCustomerPage && (
                                <StyledWrapper {...styles.salesTaxExemptMsg}>
                                    <Typography>{siteMessage("Account_Sales_Tax_Exempt_Message")}</Typography>
                                </StyledWrapper>
                            )}

                            {!IsShipToSameAsBilling && (
                                <GridItem {...CreateAccountExistingFormStyles.mainGridItem}>
                                    <StyledWrapper {...CreateAccountExistingFormStyles.sectionHeading}>
                                        Shipping Address
                                    </StyledWrapper>

                                    <GridContainer>
                                        <GridItem {...CreateAccountExistingFormStyles.halfGridItem}>
                                            <StyledWrapper {...CreateAccountExistingFormStyles.inputStyle}>
                                                <TextField
                                                    {...styles.userNameTextField}
                                                    label={translate("Company Name")}
                                                    value={companyNameShipTo}
                                                    data-test-selector="createAccount_companyName"
                                                    onChange={e => shipToCompanyNameHandler(e.currentTarget.value)}
                                                />
                                            </StyledWrapper>
                                        </GridItem>
                                        <GridItem {...CreateAccountExistingFormStyles.halfGridItem}>
                                            <StyledWrapper
                                                {...CreateAccountExistingFormStyles.inputStyle}
                                                style={{ display: IsShipToSameAsBilling ? "none" : "block" }}
                                            >
                                                <TextField
                                                    {...styles.userNameTextField}
                                                    type="tel"
                                                    autoComplete="autocomplete_off_randString"
                                                    label={translate("Phone Number *")}
                                                    value={phoneShipTo}
                                                    data-test-selector="createAccount_phoneNumber"
                                                    onChange={e => shipToPhoneHandler(e.currentTarget.value)}
                                                    error={isSubmitted && shipToPhoneError}
                                                    iconProps={{
                                                        color: "danger",
                                                        src: formErrors.phoneShipTo ? AlertTriangle : undefined,
                                                    }}
                                                    name="phoneShipTo"
                                                />
                                                <Tooltip
                                                    {...CreateAccountExistingFormStyles.toolTipMessage}
                                                    text={
                                                        siteMessage(
                                                            "Best phone number to reach you for business-related questions. Please enter only numbers. No dashes '-' or other characters are accepted.",
                                                        ) as string
                                                    }
                                                />
                                            </StyledWrapper>
                                        </GridItem>
                                        <GridItem {...CreateAccountExistingFormStyles.halfGridItem}>
                                            <StyledWrapper {...CreateAccountExistingFormStyles.inputStyle}>
                                                <TextField
                                                    {...styles.userNameTextField}
                                                    label={translate("Address1 *")}
                                                    value={address1ShipTo}
                                                    data-test-selector="createAccount_shipToAddress1"
                                                    onChange={e => shipToAddress1Handler(e.currentTarget.value)}
                                                    error={isSubmitted && shipToAddress1Error}
                                                    iconProps={{
                                                        color: "danger",
                                                        src: formErrors.address1ShipTo ? AlertTriangle : undefined,
                                                    }}
                                                    disabled={IsShipToSameAsBilling}
                                                    name="address1ShipTo"
                                                />
                                            </StyledWrapper>
                                        </GridItem>
                                        <GridItem {...CreateAccountExistingFormStyles.halfGridItem}>
                                            <StyledWrapper {...CreateAccountExistingFormStyles.inputStyle}>
                                                <TextField
                                                    {...styles.userNameTextField}
                                                    label={translate("Address2")}
                                                    value={address2ShipTo}
                                                    data-test-selector="createAccount_shipToAddress2"
                                                    onChange={e => shipToAddress2Handler(e.currentTarget.value)}
                                                    disabled={IsShipToSameAsBilling}
                                                />
                                            </StyledWrapper>
                                        </GridItem>
                                        <GridItem {...CreateAccountExistingFormStyles.halfGridItem}>
                                            <StyledWrapper {...CreateAccountExistingFormStyles.inputStyle}>
                                                <TextField
                                                    {...styles.userNameTextField}
                                                    label={translate("City *")}
                                                    value={cityShipTo}
                                                    data-test-selector="createAccount_shipToCity"
                                                    onChange={e => shipToCityHandler(e.currentTarget)}
                                                    error={isSubmitted && shiToCityError}
                                                    iconProps={{
                                                        color: "danger",
                                                        src: formErrors.cityShipTo ? AlertTriangle : undefined,
                                                    }}
                                                    disabled={IsShipToSameAsBilling}
                                                    name="cityShipTo"
                                                />
                                            </StyledWrapper>
                                        </GridItem>
                                        {defaultShipToCountry &&
                                            defaultShipToCountry.states &&
                                            defaultShipToCountry.states.length > 0 && (
                                                <GridItem {...CreateAccountExistingFormStyles.halfGridItem}>
                                                    <StyledWrapper {...CreateAccountExistingFormStyles.inputStyle}>
                                                        <Select
                                                            {...styles.departmentSelect}
                                                            label={translate("State")}
                                                            value={
                                                                shipToState && shipToState.id
                                                                // (country && country.states && country.states[0] && country.states[0].id)
                                                            }
                                                            labelPosition="top"
                                                            onChange={e => handleShipToStateChange(e)}
                                                            name="SelectShipToState"
                                                            disabled={IsShipToSameAsBilling}
                                                            error={
                                                                !!formErrors.SelectShipToState &&
                                                                formErrors.SelectShipToState
                                                            }
                                                        >
                                                            <option value="">{translate("Select State")}</option>
                                                            {defaultShipToCountry.states.map(stState => (
                                                                <option key={stState.id} value={stState.id}>
                                                                    {stState.name}
                                                                </option>
                                                            ))}
                                                        </Select>
                                                    </StyledWrapper>
                                                </GridItem>
                                            )}
                                        <GridItem {...CreateAccountExistingFormStyles.halfGridItem}>
                                            <StyledWrapper {...CreateAccountExistingFormStyles.inputStyle}>
                                                <TextField
                                                    {...styles.userNameTextField}
                                                    label={translate("Postal Code *")}
                                                    value={zipShipTo}
                                                    data-test-selector="createAccount_shipToPostalCode"
                                                    onChange={e => shipToPostalCodeHandler(e.currentTarget)}
                                                    error={isSubmitted && shippingPostalCodeError}
                                                    iconProps={{
                                                        color: "danger",
                                                        src: formErrors.zipShipTo ? AlertTriangle : undefined,
                                                    }}
                                                    disabled={IsShipToSameAsBilling}
                                                    name="zipShipTo"
                                                />
                                            </StyledWrapper>
                                        </GridItem>
                                        <GridItem {...CreateAccountExistingFormStyles.halfGridItem}>
                                            <StyledWrapper {...CreateAccountExistingFormStyles.inputStyle}>
                                                <Select
                                                    {...styles.departmentSelect}
                                                    label={translate("Country")}
                                                    value={shipToCountry && shipToCountry.id}
                                                    labelPosition="top"
                                                    onChange={e => handleShipToCountryChange(e)}
                                                    disabled={IsShipToSameAsBilling}
                                                    error={
                                                        !!formErrors.SelectShipToCountry &&
                                                        formErrors.SelectShipToCountry
                                                    }
                                                    name="SelectShipToCountry"
                                                >
                                                    {props?.countries &&
                                                        props?.countries?.map(stCountry => (
                                                            <option
                                                                key={stCountry.id}
                                                                value={stCountry.id}
                                                                selected={!!stCountry}
                                                            >
                                                                {stCountry.name}
                                                            </option>
                                                        ))}
                                                </Select>
                                            </StyledWrapper>
                                        </GridItem>
                                    </GridContainer>
                                </GridItem>
                            )}

                            {/* <StyledWrapper {...CreateAccountExistingFormStyles.paddingBottom}>
                                <CheckboxGroup {...styles.checkboxAlignment}>
                                    <Checkbox
                                        onChange={(e, value) => setIsSubscribed(value)}
                                        checked={isSubscribed}
                                        data-test-selector="createAccount_Subscription"
                                    >
                                        {siteMessage("SignIn_Sign_Up_Newsletter")}
                                    </Checkbox>
                                </CheckboxGroup>
                                <CheckboxGroup {...styles.checkboxAlignment}>
                                    <Checkbox
                                        onChange={(e, value) => creditAccountHandler(value)}
                                        checked={IsCreditAccount}
                                        data-test-selector="createAccount_Subscription"
                                    >
                                        I would like to open a credit account with Cooney Brothers.
                                    </Checkbox>
                                </CheckboxGroup>
                            </StyledWrapper> */}
                            <StyledWrapper {...CreateAccountExistingFormStyles.marginTop} {...styles.errorMsgWrap}>
                                {errorMessage && (
                                    <StyledWrapper {...styles.submitErrorGridItem}>
                                        <Typography {...CreateAccountExistingFormStyles.serverError}>
                                            {errorMessage}
                                        </Typography>
                                    </StyledWrapper>
                                )}
                                {showExistEmail && (
                                    <>
                                        <Typography {...CreateAccountExistingFormStyles.serverError}>
                                            Email Address already exists. Please{" "}
                                            <Link type="button" onClick={() => setIsResetPasswordModalOpen(true)}>
                                                click here
                                            </Link>{" "}
                                            to reset your password.
                                        </Typography>
                                        <Modal
                                            headline={translate("Reset Password")}
                                            {...styles.resetPasswordModal}
                                            isOpen={isResetPasswordModalOpen}
                                            handleClose={() => onResetPasswordClose()}
                                        >
                                            <SignInResetPasswordForm onClose={() => onResetPasswordClose()} />
                                        </Modal>
                                    </>
                                )}
                            </StyledWrapper>
                            {!isCreateNewCustomerPage && <ReCaptcha recaptchaRef={recaptchaRef} location="ContactUs" />}
                            <GridItem
                                {...styles.submitGridItem}
                                {...CreateAccountExistingFormStyles.flexStart}
                                {...CreateAccountExistingFormStyles.marginTop}
                                {...CreateAccountExistingFormStyles.removePadding}
                            >
                                {isCreateNewCustomerPage && submitClicked && <LoadingSpinner />}
                                <Button
                                    {...styles.submitButton}
                                    onClick={submitHandler}
                                    data-test-selector="createAccount_createButton"
                                    disabled={submitClicked}
                                    className={buttonTransition ? "buttonTransition" : ""}
                                >
                                    {isCreateNewCustomerPage
                                        ? translate("Create Account Now")
                                        : translate("Register Now")}
                                </Button>
                            </GridItem>
                        </GridContainer>

                        <StyledWrapper {...styles.mainContainer}>
                            <GridContainer
                                {...styles.mainGridContainer}
                                {...CreateAccountExistingFormStyles.leftPadding}
                                style={{ display: IsCreditAccount ? "block" : "none" }}
                            >
                                <StyledWrapper {...styles.subHeading}>Credit Application</StyledWrapper>
                                <GridContainer {...CreateAccountExistingFormStyles.customGridOffest}>
                                    <Typography as="p">
                                        There are two options below for submitting your credit application.
                                    </Typography>
                                    <StyledWrapper
                                        {...CreateAccountExistingFormStyles.paddingBottom}
                                        {...CreateAccountExistingFormStyles.customFlexBox}
                                    >
                                        <StyledWrapper {...CreateAccountExistingFormStyles.fourtyEightflexWidth}>
                                            <StyledWrapper {...styles.centerAlignFlexbox}>
                                                <StyledWrapper
                                                    {...CreateAccountExistingFormStyles.tenPerWidth}
                                                    {...styles.formStepsNumber}
                                                >
                                                    {" "}
                                                    1{" "}
                                                </StyledWrapper>
                                                <StyledWrapper {...CreateAccountExistingFormStyles.ninetyPerWidth}>
                                                    <Typography as="p" {...styles.formStepsHeading}>
                                                        ONLINE
                                                    </Typography>
                                                    <Typography as="p">
                                                        Thank you for choosing Cooney Brothers, Inc.
                                                    </Typography>
                                                    <Typography as="p">
                                                        Please fill in the online application form below
                                                    </Typography>
                                                    <Typography as="p" {...styles.CreateAccountExistingFormStyles}>
                                                        <StyledSpan {...CreateAccountExistingFormStyles.errorColor}>
                                                            *
                                                        </StyledSpan>{" "}
                                                        Indicates a required field
                                                    </Typography>
                                                </StyledWrapper>
                                            </StyledWrapper>
                                        </StyledWrapper>
                                        <StyledWrapper {...CreateAccountExistingFormStyles.seventyPerWidth}>
                                            <StyledWrapper {...styles.centerAlignFlexbox}>
                                                <StyledWrapper
                                                    {...CreateAccountExistingFormStyles.tenPerWidth}
                                                    {...styles.formStepsNumber}
                                                >
                                                    {" "}
                                                    2{" "}
                                                </StyledWrapper>
                                                <StyledWrapper {...CreateAccountExistingFormStyles.ninetyPerWidth}>
                                                    <Typography as="p" {...styles.formStepsHeading}>
                                                        OFFLINE
                                                    </Typography>
                                                    <Typography as="p">
                                                        Download the PDF version and send by fax or mail or use the
                                                        online form and submit directly to our accounting department.
                                                        The PDF application can be faxed to (610)279-8618. Account
                                                        status will be available within 3 business days of receiving
                                                        your credit application.{" "}
                                                        <Link
                                                            target="new"
                                                            href="/userfiles/files/creditapplication.pdf"
                                                            {...styles.underline}
                                                        >
                                                            Download the credit Application
                                                        </Link>
                                                    </Typography>
                                                </StyledWrapper>
                                            </StyledWrapper>
                                        </StyledWrapper>
                                    </StyledWrapper>
                                </GridContainer>
                                <StyledWrapper>
                                    <StyledWrapper {...CreateAccountExistingFormStyles.sectionHeading}>
                                        Company Information
                                    </StyledWrapper>
                                    <GridContainer {...CreateAccountExistingFormStyles.customGridOffest}>
                                        <GridItem {...styles.userNameGridItem} {...styles.sectionDivider}>
                                            <StyledWrapper {...CreateAccountExistingFormStyles.fourtyEightflexWidth}>
                                                <Typography {...styles.attributeTypeText} {...styles.sectionLabel}>
                                                    Organization Structure
                                                </Typography>
                                            </StyledWrapper>
                                            <StyledWrapper
                                                {...CreateAccountExistingFormStyles.pdLeftRight}
                                                {...CreateAccountExistingFormStyles.fullWidth}
                                            >
                                                <RadioGroup
                                                    {...componentStyles.radioGroup}
                                                    value={organizationStructure}
                                                    onChangeHandler={(event: any) =>
                                                        organizationStructureHandler(event.target.value)
                                                    }
                                                >
                                                    <Radio {...componentStyles.radioButton} key="Corporation">
                                                        {translate("Corporation")}
                                                    </Radio>
                                                    <Radio {...componentStyles.radioButton} key="Partnership">
                                                        {translate("Partnership")}
                                                    </Radio>
                                                    <Radio {...componentStyles.radioButton} key="Individual">
                                                        {translate("Individual")}
                                                    </Radio>
                                                </RadioGroup>
                                                <StyledWrapper
                                                    {...CreateAccountExistingFormStyles.pdLeftRight}
                                                    {...CreateAccountExistingFormStyles.fullWidth}
                                                >
                                                    <StyledWrapper {...styles.halfWidthDatePickerCss}>
                                                        <TextField
                                                            {...styles.startDatePicker}
                                                            label={translate("Business Start Date")}
                                                            value={businessStartDate}
                                                            onChange={e => businessStartDateHandler(e.currentTarget)}
                                                            required
                                                        />
                                                    </StyledWrapper>
                                                    <StyledWrapper {...styles.halfWidthCustomInputCss}>
                                                        <TextField
                                                            {...styles.userNameTextField}
                                                            label={translate("State/Date Incorporated")}
                                                            value={stateDateIncorporated}
                                                            onChange={e =>
                                                                stateDateIncorporatedHandler(e.currentTarget)
                                                            }
                                                        />
                                                    </StyledWrapper>
                                                    <StyledWrapper {...styles.inputWithLenthyLabelCss}>
                                                        {/* <TextField
                                                        {...styles.userNameTextField}
                                                        label={translate(
                                                            "How long has company operated at the above address?",
                                                        )}
                                                        value={companyOperationalTime}
                                                        onChange={e => companyOperationalTimeHandler(e.currentTarget)}
                                                        // onBlur={e => onBlurCreditFormValidationHandler(e.currentTarget)}
                                                        error={
                                                            !!formErrorsForCredit.companyOperationalTime &&
                                                            formErrorsForCredit.companyOperationalTime
                                                        }
                                                        iconProps={{
                                                            color: "danger",
                                                            src: formErrorsForCredit.companyOperationalTime
                                                                ? AlertTriangle
                                                                : undefined,
                                                        }}
                                                        name="companyOperationalTime"
                                                        required
                                                    /> */}
                                                    </StyledWrapper>
                                                    <StyledWrapper {...styles.inputWithLenthyLabelCss}>
                                                        {/* <TextField
                                                        {...styles.userNameTextField}
                                                        label={translate(
                                                            "What is the principal activity of the business?",
                                                        )}
                                                        value={principalActivity}
                                                        onChange={e => principalActivityHandler(e.currentTarget)}
                                                        onBlur={e => onBlurCreditFormValidationHandler(e.currentTarget)}
                                                        error={
                                                            !!formErrorsForCredit.principalActivity &&
                                                            formErrorsForCredit.principalActivity
                                                        }
                                                        iconProps={{
                                                            color: "danger",
                                                            src: formErrorsForCredit.principalActivity
                                                                ? AlertTriangle
                                                                : undefined,
                                                        }}
                                                        name="principalActivity"
                                                        required
                                                    /> */}
                                                    </StyledWrapper>
                                                </StyledWrapper>
                                            </StyledWrapper>
                                        </GridItem>
                                        <GridItem {...styles.userNameGridItem} {...styles.sectionDivider}>
                                            <StyledWrapper {...CreateAccountExistingFormStyles.fourtyEightflexWidth}>
                                                <Typography {...styles.attributeTypeText} {...styles.sectionLabel}>
                                                    Has the company ever bought from us in the past?
                                                </Typography>
                                            </StyledWrapper>
                                            <StyledWrapper
                                                {...CreateAccountExistingFormStyles.pdLeftRight}
                                                {...CreateAccountExistingFormStyles.fullWidth}
                                            >
                                                <RadioGroup
                                                    {...componentStyles.radioGroup}
                                                    {...CreateAccountExistingFormStyles.inlineBlock}
                                                    value={IsPastBought}
                                                    onChangeHandler={(event: any) =>
                                                        isPastBoughtHandler(event.target.value)
                                                    }
                                                >
                                                    <Radio {...componentStyles.radioButton} key="Yes" value="Yes">
                                                        {translate("Yes")}
                                                    </Radio>
                                                    <Radio {...componentStyles.radioButton} key="No" value="No">
                                                        {translate("No")}
                                                    </Radio>
                                                </RadioGroup>
                                                <Typography {...CreateAccountExistingFormStyles.inlineBlock}>
                                                    (If yes please fill the below details){" "}
                                                </Typography>
                                                <StyledWrapper
                                                    {...CreateAccountExistingFormStyles.pdLeftRight}
                                                    {...CreateAccountExistingFormStyles.fullWidth}
                                                >
                                                    <StyledWrapper {...styles.halfWidthCustomInputCss}>
                                                        {/* <TextField
                                                        {...styles.userNameTextField}
                                                        label={translate("If so, under what name")}
                                                        value={pastBuyerName}
                                                        onChange={e => pastBuyerNameHandler(e.currentTarget.value)}
                                                        onBlur={e => pastBuyerNameHandler(e.currentTarget.value)}
                                                        error={
                                                            !!formErrorsForCredit.pastBuyerName &&
                                                            formErrorsForCredit.pastBuyerName
                                                        }
                                                        required={IsPastBought === "Yes"}
                                                        name="pastBuyerName"
                                                    /> */}
                                                    </StyledWrapper>
                                                </StyledWrapper>
                                            </StyledWrapper>
                                        </GridItem>
                                        <GridItem {...styles.userNameGridItem} {...styles.sectionDivider}>
                                            <StyledWrapper {...CreateAccountExistingFormStyles.fourtyEightflexWidth}>
                                                <Typography {...styles.attributeTypeText} {...styles.sectionLabel}>
                                                    Has the company name or partnership changed in the past 5 years?
                                                </Typography>
                                            </StyledWrapper>
                                            <StyledWrapper
                                                {...CreateAccountExistingFormStyles.pdLeftRight}
                                                {...CreateAccountExistingFormStyles.fullWidth}
                                            >
                                                <StyledWrapper>
                                                    <RadioGroup
                                                        {...componentStyles.radioGroup}
                                                        {...styles.radioWithFlex}
                                                        value={IsCompanyNameChanged}
                                                        onChangeHandler={(event: any) =>
                                                            isCompanyNameChangedHandler(event.target.value)
                                                        }
                                                    >
                                                        <Radio {...componentStyles.radioButton} key="Yes" value="Yes">
                                                            {translate("Yes")}
                                                        </Radio>
                                                        <Radio {...componentStyles.radioButton} key="No" value="No">
                                                            {translate("No")}
                                                        </Radio>
                                                    </RadioGroup>
                                                </StyledWrapper>
                                                <StyledWrapper {...styles.halfWidthCustomInputCss}>
                                                    {/* <TextField
                                                    label={translate("If so give former name")}
                                                    value={formerName}
                                                    onChange={e => formerNameHandler(e.currentTarget.value)}
                                                    onBlur={e => formerNameHandler(e.currentTarget.value)}
                                                    error={
                                                        !!formErrorsForCredit.formerName &&
                                                        formErrorsForCredit.formerName
                                                    }
                                                    required={IsCompanyNameChanged === "Yes"}
                                                    name="formerName"
                                                /> */}
                                                </StyledWrapper>
                                            </StyledWrapper>
                                        </GridItem>
                                        <GridItem {...styles.userNameGridItem} {...styles.sectionDivider}>
                                            <StyledWrapper {...CreateAccountExistingFormStyles.fourtyEightflexWidth}>
                                                <Typography {...styles.attributeTypeText} {...styles.sectionLabel}>
                                                    Are you Sales Tax Exempt?
                                                </Typography>
                                            </StyledWrapper>
                                            <StyledWrapper
                                                {...CreateAccountExistingFormStyles.pdLeftRight}
                                                {...CreateAccountExistingFormStyles.fullWidth}
                                            >
                                                <RadioGroup
                                                    {...componentStyles.radioGroup}
                                                    {...CreateAccountExistingFormStyles.inlineBlock}
                                                    value={IsSalesTaxExempt}
                                                    onChangeHandler={(event: any) =>
                                                        isSalesTaxExemptHandler(event.target.value)
                                                    }
                                                >
                                                    <Radio {...componentStyles.radioButton} key="Yes" value="Yes">
                                                        {translate("Yes")}
                                                    </Radio>
                                                    <Radio {...componentStyles.radioButton} key="No" value="No">
                                                        {translate("No")}
                                                    </Radio>
                                                </RadioGroup>
                                                <Typography as="p" {...CreateAccountExistingFormStyles.inlineBlock}>
                                                    (If yes, please email exemption certificate to{" "}
                                                    <Link
                                                        target="_blank"
                                                        href="mailto:acctsreceivable@cooneybrothers.com"
                                                    >
                                                        acctsreceivable@cooneybrothers.com
                                                    </Link>
                                                    )
                                                </Typography>
                                                <StyledWrapper
                                                    {...CreateAccountExistingFormStyles.pdLeftRight}
                                                    {...CreateAccountExistingFormStyles.fullWidth}
                                                >
                                                    <StyledWrapper {...styles.halfWidthCustomInputCss}>
                                                        {/* <TextField
                                                        {...styles.userNameTextField}
                                                        label={translate("A/P Contact")}
                                                        value={apContact}
                                                        onChange={e => apContactHandler(e.currentTarget)}
                                                        onBlur={e => onBlurCreditFormValidationHandler(e.currentTarget)}
                                                        error={
                                                            !!formErrorsForCredit.apContact &&
                                                            formErrorsForCredit.apContact
                                                        }
                                                        iconProps={{
                                                            color: "danger",
                                                            src: formErrorsForCredit.apContact
                                                                ? AlertTriangle
                                                                : undefined,
                                                        }}
                                                        name="apContact"
                                                        required
                                                    /> */}
                                                    </StyledWrapper>
                                                    <StyledWrapper {...styles.halfWidthCustomInputCss}>
                                                        {/* <TextField
                                                        {...styles.userNameTextField}
                                                        label={translate("A/P Contact Email")}
                                                        value={apContactEmail}
                                                        onChange={e => apContactEmailHandler(e.currentTarget.value)}
                                                        onBlur={e => onBlurCreditFormValidationHandler(e.currentTarget)}
                                                        error={
                                                            !!formErrorsForCredit.apContactEmail &&
                                                            formErrorsForCredit.apContactEmail
                                                        }
                                                        iconProps={{
                                                            color: "danger",
                                                            src: formErrorsForCredit.apContactEmail
                                                                ? AlertTriangle
                                                                : undefined,
                                                        }}
                                                        name="apContactEmail"
                                                        required
                                                    /> */}
                                                    </StyledWrapper>
                                                </StyledWrapper>
                                            </StyledWrapper>
                                        </GridItem>
                                        <GridItem {...styles.userNameGridItem} {...styles.creditApplicationLastDiv}>
                                            <StyledWrapper {...CreateAccountExistingFormStyles.fourtyEightflexWidth}>
                                                <Typography {...styles.attributeTypeText} {...styles.sectionLabel}>
                                                    How should invoices be sent?
                                                </Typography>
                                            </StyledWrapper>
                                            <StyledWrapper
                                                {...CreateAccountExistingFormStyles.pdLeftRight}
                                                {...CreateAccountExistingFormStyles.fullWidth}
                                            >
                                                <RadioGroup
                                                    {...componentStyles.radioGroup}
                                                    value={InvoicesBeSent}
                                                    onChangeHandler={(event: any) =>
                                                        handleInvoicesBeSent(event.currentTarget)
                                                    }
                                                >
                                                    <Radio
                                                        {...componentStyles.radioButton}
                                                        key="invemail"
                                                        value="e-mail"
                                                    >
                                                        {translate("e-mail")}
                                                    </Radio>
                                                    <Radio
                                                        {...componentStyles.radioButton}
                                                        key="invFaxNo"
                                                        value="fax number"
                                                    >
                                                        {translate("fax number")}
                                                    </Radio>
                                                    <Radio
                                                        {...componentStyles.radioButton}
                                                        key="invPostalEamil"
                                                        value="Us Postal email"
                                                    >
                                                        {translate("US Postal email")}
                                                    </Radio>
                                                </RadioGroup>
                                                <StyledWrapper
                                                    {...CreateAccountExistingFormStyles.pdLeftRight}
                                                    {...CreateAccountExistingFormStyles.fullWidth}
                                                >
                                                    <StyledWrapper
                                                        {...styles.halfWidthCustomInputCss}
                                                        style={{
                                                            display:
                                                                InvoicesBeSent === "Us Postal email" ? "block" : "none",
                                                        }}
                                                    >
                                                        <Typography
                                                            as="p"
                                                            {...CreateAccountExistingFormStyles.errorColor}
                                                        >
                                                            ** Billing Address will be used **
                                                        </Typography>
                                                    </StyledWrapper>
                                                    <StyledWrapper
                                                        {...styles.halfWidthCustomInputCss}
                                                        style={{
                                                            display: InvoicesBeSent === "e-mail" ? "block" : "none",
                                                        }}
                                                    >
                                                        {/* <TextField
                                                        {...styles.userNameTextField}
                                                        label={translate("Invoice Email")}
                                                        value={invEmailText}
                                                        onChange={e => invEmailHandler(e.currentTarget)}
                                                        onBlur={e => onBlurCreditFormValidationHandler(e.currentTarget)}
                                                        error={
                                                            !!formErrorsForCredit.invEmailText &&
                                                            formErrorsForCredit.invEmailText
                                                        }
                                                        iconProps={{
                                                            color: "danger",
                                                            src: formErrorsForCredit.invEmailText
                                                                ? AlertTriangle
                                                                : undefined,
                                                        }}
                                                        name={InvoicesBeSent === "e-mail" ? "invEmailText" : ""}
                                                        required={InvoicesBeSent === "e-mail"}
                                                    /> */}
                                                    </StyledWrapper>
                                                    <StyledWrapper
                                                        {...styles.halfWidthCustomInputCss}
                                                        style={{
                                                            display: InvoicesBeSent === "fax number" ? "block" : "none",
                                                        }}
                                                    >
                                                        {/* <TextField
                                                        {...styles.userNameTextField}
                                                        type="tel"
                                                        label={translate("Invoice Fax Number")}
                                                        // name="invFaxNumberText"
                                                        value={invFaxNumberText}
                                                        onChange={e => invFaxNumberHandler(e.currentTarget)}
                                                        // onBlur={e => onBlurCreditFormValidationHandler(e.currentTarget)}
                                                        onBlur={e => onBlurCreditFormValidationHandler(e.currentTarget)}
                                                        error={
                                                            !!formErrorsForCredit.invFaxText &&
                                                            formErrorsForCredit.invFaxText
                                                        }
                                                        name={InvoicesBeSent === "fax number" ? "invFaxText" : ""}
                                                        required={InvoicesBeSent === "fax number"}
                                                    /> */}
                                                    </StyledWrapper>
                                                </StyledWrapper>
                                            </StyledWrapper>
                                        </GridItem>
                                    </GridContainer>
                                </StyledWrapper>
                                <StyledWrapper {...CreateAccountExistingFormStyles.fullWidth}>
                                    <StyledWrapper {...CreateAccountExistingFormStyles.sectionHeading}>
                                        Bank Reference (Checking)
                                    </StyledWrapper>
                                    <StyledWrapper
                                        {...CreateAccountExistingFormStyles.customInputCss}
                                        className="fullWidthForMobileDevices"
                                    >
                                        {/* <TextField
                                        {...styles.userNameTextField}
                                        label={translate("Bank Name")}
                                        value={bankName}
                                        onChange={e => brcNameHandler(e.currentTarget)}
                                        onBlur={e => onBlurCreditFormValidationHandler(e.currentTarget)}
                                        error={!!formErrorsForCredit.bankName && formErrorsForCredit.bankName}
                                        iconProps={{
                                            color: "danger",
                                            src: formErrorsForCredit.bankName ? AlertTriangle : undefined,
                                        }}
                                        name="bankName"
                                        required
                                    /> */}
                                    </StyledWrapper>
                                    <StyledWrapper
                                        {...CreateAccountExistingFormStyles.customInputCss}
                                        className="fullWidthForMobileDevices"
                                    >
                                        {/* <TextField
                                        {...styles.userNameTextField}
                                        label={translate("Account#")}
                                        value={bankAccount}
                                        onChange={e => brcAccountHandler(e.currentTarget)}
                                        onBlur={e => onBlurCreditFormValidationHandler(e.currentTarget)}
                                        error={!!formErrorsForCredit.bankAccount && formErrorsForCredit.bankAccount}
                                        iconProps={{
                                            color: "danger",
                                            src: formErrorsForCredit.bankAccount ? AlertTriangle : undefined,
                                        }}
                                        name="bankAccount"
                                        required
                                    /> */}
                                    </StyledWrapper>
                                    <StyledWrapper
                                        {...CreateAccountExistingFormStyles.customInputCss}
                                        className="fullWidthForMobileDevices"
                                    >
                                        {/* <TextField
                                        {...styles.userNameTextField}
                                        label={translate("Address")}
                                        value={bankAddress}
                                        onChange={e => brcAddressHandler(e.currentTarget)}
                                        onBlur={e => onBlurCreditFormValidationHandler(e.currentTarget)}
                                        error={!!formErrorsForCredit.bankAddress && formErrorsForCredit.bankAddress}
                                        iconProps={{
                                            color: "danger",
                                            src: formErrorsForCredit.bankAddress ? AlertTriangle : undefined,
                                        }}
                                        name="bankAddress"
                                        required
                                    /> */}
                                    </StyledWrapper>
                                    <StyledWrapper
                                        {...CreateAccountExistingFormStyles.customInputCss}
                                        className="fullWidthForMobileDevices"
                                    >
                                        {/* <TextField
                                        {...styles.userNameTextField}
                                        type="tel"
                                        autoComplete="autocomplete_off_randString"
                                        label={translate("Phone Number")}
                                        value={bankPhone}
                                        onChange={e => brcPhoneNumberHandler(e.currentTarget)}
                                        onBlur={e => onBlurCreditFormValidationHandler(e.currentTarget)}
                                        error={!!formErrorsForCredit.bankPhone && formErrorsForCredit.bankPhone}
                                        iconProps={{
                                            color: "danger",
                                            src: formErrorsForCredit.bankPhone ? AlertTriangle : undefined,
                                        }}
                                        name="bankPhone"
                                        required
                                    /> */}
                                        {/* <Tooltip
                                {...CreateAccountExistingFormStyles.toolTipMessage}
                                text={
                                    siteMessage(
                                        "Best phone number to reach you for business-related questions. Please enter only numbers. No dashes '-' or other characters are accepted.",
                                    ) as string
                                }
                            /> */}
                                    </StyledWrapper>
                                    <StyledWrapper
                                        {...CreateAccountExistingFormStyles.customInputCss}
                                        className="fullWidthForMobileDevices"
                                    >
                                        {/* <TextField
                                        {...styles.userNameTextField}
                                        type="tel"
                                        label={translate("Fax#")}
                                        value={bankFax}
                                        onChange={e => brcFaxHandler(e.currentTarget)}
                                        onBlur={e => onBlurCreditFormValidationHandler(e.currentTarget)}
                                        error={!!formErrorsForCredit.bankFax && formErrorsForCredit.bankFax}
                                        name="bankFax"
                                    /> */}
                                    </StyledWrapper>
                                </StyledWrapper>
                                <StyledWrapper>
                                    <StyledWrapper {...CreateAccountExistingFormStyles.sectionHeading}>
                                        Business Reference (Where credit is now extended)
                                    </StyledWrapper>
                                    <GridContainer {...CreateAccountExistingFormStyles.customGridOffest}>
                                        <StyledWrapper {...CreateAccountExistingFormStyles.customFlexBox}>
                                            <StyledWrapper {...CreateAccountExistingFormStyles.fourtyEightflexWidth}>
                                                <StyledWrapper
                                                    {...CreateAccountExistingFormStyles.customInputCss}
                                                    {...CreateAccountExistingFormStyles.fullWidth}
                                                >
                                                    <StyledWrapper>
                                                        <Typography
                                                            {...styles.attributeTypeText}
                                                            {...styles.sectionLabel}
                                                        >
                                                            Reference 1:
                                                        </Typography>
                                                    </StyledWrapper>
                                                    <StyledWrapper {...styles.refCustomInputCss}>
                                                        {/* <TextField
                                                        {...styles.userNameTextField}
                                                        label={translate("Company Name")}
                                                        value={businessRefCompName1}
                                                        onChange={e => businessRefCompName1Handler(e.currentTarget)}
                                                        onBlur={e => onBlurCreditFormValidationHandler(e.currentTarget)}
                                                        error={
                                                            !!formErrorsForCredit.businessRefCompName1 &&
                                                            formErrorsForCredit.businessRefCompName1
                                                        }
                                                        iconProps={{
                                                            color: "danger",
                                                            src: formErrorsForCredit.businessRefCompName1
                                                                ? AlertTriangle
                                                                : undefined,
                                                        }}
                                                        name="businessRefCompName1"
                                                        required
                                                    /> */}
                                                    </StyledWrapper>
                                                    <StyledWrapper {...styles.refCustomInputCss}>
                                                        {/* <TextField
                                                        {...styles.userNameTextField}
                                                        label={translate("Name")}
                                                        value={businessRefName1}
                                                        onChange={e => businessRefName1Handler(e.currentTarget)}
                                                        onBlur={e => onBlurCreditFormValidationHandler(e.currentTarget)}
                                                        error={
                                                            !!formErrorsForCredit.businessRefName1 &&
                                                            formErrorsForCredit.businessRefName1
                                                        }
                                                        iconProps={{
                                                            color: "danger",
                                                            src: formErrorsForCredit.businessRefName1
                                                                ? AlertTriangle
                                                                : undefined,
                                                        }}
                                                        name="businessRefName1"
                                                        required
                                                    /> */}
                                                    </StyledWrapper>
                                                    <StyledWrapper {...styles.refCustomInputCss}>
                                                        <TextField
                                                            {...styles.userNameTextField}
                                                            label={translate("Title")}
                                                            value={businessRefTitle1}
                                                            onChange={e =>
                                                                businessRefTitle1Handler(e.currentTarget.value)
                                                            }
                                                            error={isSubmitted}
                                                        />
                                                    </StyledWrapper>
                                                    <StyledWrapper {...styles.refCustomInputCss}>
                                                        {/* <TextField
                                                        {...styles.userNameTextField}
                                                        label={translate("Address")}
                                                        value={businessRefAddress1}
                                                        onChange={e => businessRefAddress1Handler(e.currentTarget)}
                                                        onBlur={e => onBlurCreditFormValidationHandler(e.currentTarget)}
                                                        error={
                                                            !!formErrorsForCredit.businessRefAddress1 &&
                                                            formErrorsForCredit.businessRefAddress1
                                                        }
                                                        iconProps={{
                                                            color: "danger",
                                                            src: formErrorsForCredit.businessRefAddress1
                                                                ? AlertTriangle
                                                                : undefined,
                                                        }}
                                                        name="businessRefAddress1"
                                                        required
                                                    /> */}
                                                    </StyledWrapper>
                                                    <StyledWrapper {...styles.refCustomInputCss}>
                                                        {/* <TextField
                                                        {...styles.userNameTextField}
                                                        type="tel"
                                                        label={translate("Phone")}
                                                        autoComplete="autocomplete_off_randString"
                                                        value={businessRefPhone1}
                                                        onChange={e => businessRefPhone1Handler(e.currentTarget)}
                                                        onBlur={e => onBlurCreditFormValidationHandler(e.currentTarget)}
                                                        error={
                                                            !!formErrorsForCredit.businessRefPhone1 &&
                                                            formErrorsForCredit.businessRefPhone1
                                                        }
                                                        iconProps={{
                                                            color: "danger",
                                                            src: formErrorsForCredit.businessRefPhone1
                                                                ? AlertTriangle
                                                                : undefined,
                                                        }}
                                                        name="businessRefPhone1"
                                                        required
                                                    /> */}
                                                    </StyledWrapper>
                                                    <StyledWrapper {...styles.refCustomInputCss}>
                                                        {/* <TextField
                                                        {...styles.userNameTextField}
                                                        type="tel"
                                                        label={translate("Fax#")}
                                                        value={businessRefFax1}
                                                        onChange={e => businessRefFax1Handler(e.currentTarget)}
                                                        onBlur={e => onBlurCreditFormValidationHandler(e.currentTarget)}
                                                        error={
                                                            !!formErrorsForCredit.businessRefFax1 &&
                                                            formErrorsForCredit.businessRefFax1
                                                        }
                                                        name="businessRefFax1"
                                                    /> */}
                                                    </StyledWrapper>
                                                </StyledWrapper>
                                            </StyledWrapper>
                                            <StyledWrapper {...CreateAccountExistingFormStyles.fourtyEightflexWidth}>
                                                <StyledWrapper
                                                    {...CreateAccountExistingFormStyles.customInputCss}
                                                    {...CreateAccountExistingFormStyles.fullWidth}
                                                >
                                                    <StyledWrapper>
                                                        <Typography
                                                            {...styles.attributeTypeText}
                                                            {...styles.sectionLabel}
                                                        >
                                                            Reference 2:
                                                        </Typography>
                                                    </StyledWrapper>
                                                    <StyledWrapper {...styles.refCustomInputCss}>
                                                        {/* <TextField
                                                        {...styles.userNameTextField}
                                                        label={translate("Company Name")}
                                                        value={businessRefCompName2}
                                                        onChange={e => businessRefCompName2Handler(e.currentTarget)}
                                                        onBlur={e => onBlurCreditFormValidationHandler(e.currentTarget)}
                                                        error={
                                                            !!formErrorsForCredit.businessRefCompName2 &&
                                                            formErrorsForCredit.businessRefCompName2
                                                        }
                                                        iconProps={{
                                                            color: "danger",
                                                            src: formErrorsForCredit.businessRefCompName2
                                                                ? AlertTriangle
                                                                : undefined,
                                                        }}
                                                        name="businessRefCompName2"
                                                        required
                                                    /> */}
                                                    </StyledWrapper>
                                                    <StyledWrapper {...styles.refCustomInputCss}>
                                                        {/* <TextField
                                                        {...styles.userNameTextField}
                                                        label={translate("Name")}
                                                        value={businessRefName2}
                                                        onChange={e => businessRefName2Handler(e.currentTarget)}
                                                        onBlur={e => onBlurCreditFormValidationHandler(e.currentTarget)}
                                                        error={
                                                            !!formErrorsForCredit.businessRefName2 &&
                                                            formErrorsForCredit.businessRefName2
                                                        }
                                                        iconProps={{
                                                            color: "danger",
                                                            src: formErrorsForCredit.businessRefName2
                                                                ? AlertTriangle
                                                                : undefined,
                                                        }}
                                                        name="businessRefName2"
                                                        required
                                                    /> */}
                                                    </StyledWrapper>
                                                    <StyledWrapper {...styles.refCustomInputCss}>
                                                        <TextField
                                                            {...styles.userNameTextField}
                                                            label={translate("Title")}
                                                            value={businessRefTitle2}
                                                            onChange={e =>
                                                                businessRefTitle2Handler(e.currentTarget.value)
                                                            }
                                                            error={isSubmitted}
                                                        />
                                                    </StyledWrapper>
                                                    <StyledWrapper {...styles.refCustomInputCss}>
                                                        {/* <TextField
                                                        {...styles.userNameTextField}
                                                        label={translate("Address")}
                                                        value={businessRefAddress2}
                                                        onChange={e => businessRefAddress2Handler(e.currentTarget)}
                                                        onBlur={e => onBlurCreditFormValidationHandler(e.currentTarget)}
                                                        error={
                                                            !!formErrorsForCredit.businessRefAddress2 &&
                                                            formErrorsForCredit.businessRefAddress2
                                                        }
                                                        iconProps={{
                                                            color: "danger",
                                                            src: formErrorsForCredit.businessRefAddress2
                                                                ? AlertTriangle
                                                                : undefined,
                                                        }}
                                                        name="businessRefAddress2"
                                                        required
                                                    /> */}
                                                    </StyledWrapper>
                                                    <StyledWrapper {...styles.refCustomInputCss}>
                                                        {/* <TextField
                                                        {...styles.userNameTextField}
                                                        type="tel"
                                                        autoComplete="autocomplete_off_randString"
                                                        label={translate("Phone")}
                                                        value={businessRefPhone2}
                                                        onChange={e => businessRefPhone2Handler(e.currentTarget)}
                                                        onBlur={e => onBlurCreditFormValidationHandler(e.currentTarget)}
                                                        error={
                                                            !!formErrorsForCredit.businessRefPhone2 &&
                                                            formErrorsForCredit.businessRefPhone2
                                                        }
                                                        iconProps={{
                                                            color: "danger",
                                                            src: formErrorsForCredit.businessRefPhone2
                                                                ? AlertTriangle
                                                                : undefined,
                                                        }}
                                                        name="businessRefPhone2"
                                                        required
                                                    /> */}
                                                    </StyledWrapper>
                                                    <StyledWrapper {...styles.refCustomInputCss}>
                                                        {/* <TextField
                                                        {...styles.userNameTextField}
                                                        label={translate("Fax#")}
                                                        value={businessRefFax2}
                                                        onChange={e => businessRefFax2Handler(e.currentTarget)}
                                                        onBlur={e => onBlurCreditFormValidationHandler(e.currentTarget)}
                                                        error={
                                                            !!formErrorsForCredit.businessRefFax2 &&
                                                            formErrorsForCredit.businessRefFax2
                                                        }
                                                        name="businessRefFax2"
                                                    /> */}
                                                    </StyledWrapper>
                                                </StyledWrapper>
                                            </StyledWrapper>
                                        </StyledWrapper>
                                    </GridContainer>
                                    <GridContainer {...CreateAccountExistingFormStyles.customGridOffest}>
                                        <GridItem {...styles.userNameGridItem} {...styles.sectionDivider}>
                                            <StyledWrapper {...CreateAccountExistingFormStyles.fullWidth}>
                                                <Typography {...styles.attributeTypeText} {...styles.sectionLabel}>
                                                    Has applicant or any of its Owners, Principals, Partners, Officers,
                                                    or Directors ever filed a voluntary petition in bankruptcy, been
                                                    adjudged bankrupt, or made an assignment for the benefit of
                                                    creditors?
                                                </Typography>
                                            </StyledWrapper>
                                            <StyledWrapper
                                                {...CreateAccountExistingFormStyles.pdLeftRight}
                                                {...CreateAccountExistingFormStyles.fullWidth}
                                            >
                                                <RadioGroup
                                                    {...componentStyles.radioGroup}
                                                    value={IsBankrupt}
                                                    onChangeHandler={(event: any) =>
                                                        isBankruptHandler(event.target.value)
                                                    }
                                                >
                                                    <Radio {...componentStyles.radioButton} key="Yes" value="Yes">
                                                        {translate("Yes")}
                                                    </Radio>
                                                    <Radio {...componentStyles.radioButton} key="No" value="No">
                                                        {translate("No")}
                                                    </Radio>
                                                </RadioGroup>
                                                <StyledWrapper
                                                    {...styles.halfWidthCustomInputCss}
                                                    style={{ display: IsBankrupt === "Yes" ? "block" : "none" }}
                                                >
                                                    {/* <TextField
                                                    label={translate("Please explain:")}
                                                    {...styles.userNameTextField}
                                                    value={IsBankruptText}
                                                    onChange={e => isBankruptTextHandler(e.currentTarget.value)}
                                                    onBlur={e => isBankruptTextHandler(e.currentTarget.value)}
                                                    error={
                                                        !!formErrorsForCredit.IsBankruptText &&
                                                        formErrorsForCredit.IsBankruptText
                                                    }
                                                    required={IsBankrupt === "Yes"}
                                                    name="IsBankruptText"
                                                /> */}
                                                </StyledWrapper>
                                            </StyledWrapper>
                                        </GridItem>
                                        <GridItem {...styles.userNameGridItem} {...styles.creditApplicationLastDiv}>
                                            <StyledWrapper {...CreateAccountExistingFormStyles.fullWidth}>
                                                <Typography {...styles.attributeTypeText} {...styles.sectionLabel}>
                                                    Has a tax lien or civil suit been filed against Applicant, or any of
                                                    its Owners, Principals, Partners, Officers or Directors within the
                                                    last 6 years?
                                                </Typography>
                                            </StyledWrapper>
                                            <StyledWrapper
                                                {...CreateAccountExistingFormStyles.pdLeftRight}
                                                {...CreateAccountExistingFormStyles.fullWidth}
                                            >
                                                <RadioGroup
                                                    {...componentStyles.radioGroup}
                                                    value={IsSuitFiled}
                                                    onChangeHandler={(event: any) =>
                                                        isSuitFiledHandler(event.target.value)
                                                    }
                                                >
                                                    <Radio {...componentStyles.radioButton} key="Yes" value="Yes">
                                                        {translate("Yes")}
                                                    </Radio>
                                                    <Radio {...componentStyles.radioButton} key="No" value="No">
                                                        {translate("No")}
                                                    </Radio>
                                                </RadioGroup>
                                                <StyledWrapper
                                                    {...styles.halfWidthCustomInputCss}
                                                    style={{ display: IsSuitFiled === "Yes" ? "block" : "none" }}
                                                >
                                                    {/* <TextField
                                                    label={translate("Please explain:")}
                                                    {...styles.userNameTextField}
                                                    value={suitFiledText}
                                                    onChange={e => suitFiledTextHandler(e.currentTarget.value)}
                                                    onBlur={e => suitFiledTextHandler(e.currentTarget.value)}
                                                    error={
                                                        !!formErrorsForCredit.suitFiledText &&
                                                        formErrorsForCredit.suitFiledText
                                                    }
                                                    required={IsSuitFiled === "Yes"}
                                                    name="suitFiledText"
                                                /> */}
                                                </StyledWrapper>
                                            </StyledWrapper>
                                        </GridItem>
                                    </GridContainer>
                                </StyledWrapper>
                                <StyledWrapper {...styles.fullWidth}>
                                    <StyledWrapper {...CreateAccountExistingFormStyles.sectionHeading}>
                                        Shipping And Receiving
                                    </StyledWrapper>
                                    <GridContainer {...CreateAccountExistingFormStyles.customGridOffest}>
                                        <GridItem {...styles.oneFourthGridItem}>
                                            <Typography {...styles.attributeTypeText} {...styles.sectionLabel}>
                                                Do you have a UPS or FedEx account # to be used for shipping?
                                            </Typography>
                                        </GridItem>
                                        <GridItem {...styles.thirdFourthGridItem}>
                                            <StyledWrapper
                                                {...CreateAccountExistingFormStyles.pdLeftRight}
                                                {...CreateAccountExistingFormStyles.fullWidth}
                                            >
                                                <RadioGroup
                                                    {...componentStyles.radioGroup}
                                                    {...CreateAccountExistingFormStyles.inlineBlock}
                                                    value={IsUpsAccount}
                                                    onChangeHandler={(event: any) =>
                                                        isUpsAccountHandler(event.target.value)
                                                    }
                                                >
                                                    <Radio {...componentStyles.radioButton} key="Yes">
                                                        {translate("Yes")}
                                                    </Radio>
                                                    <Radio {...componentStyles.radioButton} key="No">
                                                        {translate("No")}
                                                    </Radio>
                                                </RadioGroup>
                                                <Typography {...CreateAccountExistingFormStyles.inlineBlock}>
                                                    {translate("(If yes, please fill in the Account number below.)")}
                                                </Typography>
                                                <StyledWrapper {...styles.columnLayout}>
                                                    <StyledWrapper {...styles.fullWidthInput}>
                                                        <TextField
                                                            {...styles.userNameTextField}
                                                            label={translate("Account")}
                                                            value={upsAccount}
                                                            onChange={e => upsAccountHandler(e.currentTarget.value)}
                                                            error={
                                                                !!formErrorsForCredit.upsAccount &&
                                                                formErrorsForCredit.upsAccount
                                                            }
                                                            required={IsUpsAccount === "Yes"}
                                                            name="upsAccount"
                                                        />
                                                    </StyledWrapper>
                                                    <StyledWrapper {...styles.fullWidthInput}>
                                                        {/* <TextField
                                                        {...styles.userNameTextField}
                                                        label={translate("What are your receiving hours?")}
                                                        value={receivingHours}
                                                        onChange={e => receivingHoursHandler(e.currentTarget)}
                                                        onBlur={e => onBlurCreditFormValidationHandler(e.currentTarget)}
                                                        error={
                                                            !!formErrorsForCredit.receivingHours &&
                                                            formErrorsForCredit.receivingHours
                                                        }
                                                        name="receivingHours"
                                                        iconProps={{
                                                            color: "danger",
                                                            src: formErrorsForCredit.receivingHours
                                                                ? AlertTriangle
                                                                : undefined,
                                                        }}
                                                        required
                                                    /> */}
                                                    </StyledWrapper>
                                                </StyledWrapper>
                                            </StyledWrapper>
                                        </GridItem>
                                    </GridContainer>
                                </StyledWrapper>
                                <StyledWrapper {...styles.fullWidth}>
                                    <StyledWrapper {...CreateAccountExistingFormStyles.sectionHeading}>
                                        Credit Information
                                    </StyledWrapper>
                                    <GridContainer {...styles.gridOffsetMargin}>
                                        <GridItem {...styles.userNameGridItem} {...styles.creditApplicationLastDiv}>
                                            <GridItem {...styles.oneFourthGridItem}>
                                                <Typography {...styles.attributeTypeText} {...styles.sectionLabel}>
                                                    Terms: 1% 10 Days; Net 30 Days. We understand your terms and agree
                                                    to abide by them. *
                                                </Typography>
                                            </GridItem>
                                            <GridItem {...styles.thirdFourthGridItem}>
                                                <StyledWrapper
                                                    {...CreateAccountExistingFormStyles.pdLeftRight}
                                                    {...CreateAccountExistingFormStyles.fullWidth}
                                                >
                                                    <RadioGroup
                                                        {...componentStyles.radioGroup}
                                                        value={IsTerms}
                                                        onChangeHandler={(event: any) => isTermsHandler(event.target)}
                                                        name="IsTerms"
                                                    >
                                                        <Radio {...componentStyles.radioButton} key="Accept">
                                                            {translate("Accept")}
                                                        </Radio>
                                                        <Radio {...componentStyles.radioButton} key="Reject">
                                                            {translate("Reject")}
                                                        </Radio>
                                                    </RadioGroup>
                                                    {formErrorsForCredit.IsTerms ? formErrorsForCredit.IsTerms : ""}
                                                </StyledWrapper>
                                                <StyledWrapper {...styles.fullWidthInput}>
                                                    <TextField
                                                        {...styles.userNameTextField}
                                                        label={translate("Requested credit limit")}
                                                        value={creditLimit}
                                                        onChange={e => creditLimitHandler(e.currentTarget.value)}
                                                        error={isSubmitted}
                                                    />
                                                </StyledWrapper>
                                            </GridItem>
                                        </GridItem>
                                    </GridContainer>
                                </StyledWrapper>
                                <GridItem
                                    {...styles.submitGridItem}
                                    {...CreateAccountExistingFormStyles.flexStart}
                                    {...CreateAccountExistingFormStyles.marginTop}
                                    {...CreateAccountExistingFormStyles.removePadding}
                                >
                                    <Button
                                        {...styles.submitButton}
                                        onClick={submitHandler}
                                        data-test-selector="createAccount_createButton"
                                        className={buttonTransition ? "buttonTransition" : ""}
                                    >
                                        {translate("Submit Application and Register Now")}
                                    </Button>
                                </GridItem>
                            </GridContainer>
                            {!isCreateNewCustomerPage && (
                                <Typography as="p" {...CreateAccountExistingFormStyles.termsAndConditions}>
                                    By clicking the "Register Now" button, you agree to Cooney Brothers{" "}
                                    <Link
                                        {...CreateAccountExistingFormStyles.linkStyle}
                                        href="/TermsandConditions"
                                        target="_blank"
                                    >
                                        Terms and Conditions
                                    </Link>
                                </Typography>
                            )}
                        </StyledWrapper>
                    </StyledWrapper>
                </form>
            </StyledWrapper>
        </LoadingOverlay>
    );
};

export default withHistory(CreateAccountNewForm);
